document.addEventListener('DOMContentLoaded', function () {
    const selectTipo = document.getElementById('HKN_TipoInscripcion__c');
    const extraCheckboxBlocks = document.querySelectorAll('.activity-input-checkbox[data-pay]');
    const REDIRECT_DELAY_MS = 1200;
    const PENDING_REDIRECT_DELAY_MS = 3600;
    const redirectOverlayId = 'hk-activity-redirect-overlay';
    const redirectStylesId = 'hk-activity-redirect-style';
    const reservationModalId = 'hk-activity-reservation-modal';
    const reservationStylesId = 'hk-activity-reservation-style';
    const submitProgressStylesId = 'hk-activity-submit-progress-style';
    const familyModalId = 'hk-family-helper-modal';
    const familyStorageUpdateKey = 'hk_family_members_updated';

    function lockFormForRedirect(currentForm) {
        if (!currentForm) return;
        currentForm.classList.add('is-redirecting');
        currentForm.setAttribute('aria-busy', 'true');
        currentForm.querySelectorAll('input, select, textarea, button').forEach((field) => {
            field.disabled = true;
        });
    }

    function showRedirectOverlay(message) {
        if (!document.getElementById(redirectStylesId)) {
            const style = document.createElement('style');
            style.id = redirectStylesId;
            style.textContent = `
                body.hk-is-redirecting {
                    overflow: hidden;
                }
                #${redirectOverlayId} {
                    position: fixed;
                    inset: 0;
                    z-index: 9999;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(15, 23, 42, 0.45);
                    backdrop-filter: blur(2px);
                    opacity: 0;
                    pointer-events: none;
                    transition: opacity 0.25s ease;
                }
                #${redirectOverlayId}.is-visible {
                    opacity: 1;
                    pointer-events: all;
                }
                #${redirectOverlayId} .hk-redirect-card {
                    background: #ffffff;
                    border-radius: 8px;
                    padding: 18px 22px;
                    width: min(320px, calc(100vw - 48px));
                    text-align: center;
                    box-shadow: 0 18px 44px rgba(15, 23, 42, 0.25);
                }
                #${redirectOverlayId} .hk-redirect-spinner {
                    display: inline-block;
                    width: 26px;
                    height: 26px;
                    border-radius: 999px;
                    border: 3px solid #d7e4ea;
                    border-top-color: #00ccd9;
                    animation: hk-redirect-spin 0.8s linear infinite;
                    margin-bottom: 10px;
                }
                #${redirectOverlayId} .hk-redirect-message {
                    margin: 0;
                    font-size: 14px;
                    font-weight: 700;
                    color: #16303d;
                }
                #${redirectOverlayId} .hk-redirect-progress {
                    position: relative;
                    width: 100%;
                    height: 6px;
                    margin-top: 14px;
                    overflow: hidden;
                    border-radius: 999px;
                    background: #d7e4ea;
                }
                #${redirectOverlayId} .hk-redirect-progress::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    width: 46%;
                    border-radius: inherit;
                    background: #00ccd9;
                    animation: hk-redirect-progress 1.1s ease-in-out infinite;
                }
                @keyframes hk-redirect-spin {
                    to { transform: rotate(360deg); }
                }
                @keyframes hk-redirect-progress {
                    from { transform: translateX(-105%); }
                    to { transform: translateX(225%); }
                }
            `;
            document.head.appendChild(style);
        }

        let overlay = document.getElementById(redirectOverlayId);
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = redirectOverlayId;
            overlay.innerHTML = `
                <div class="hk-redirect-card" role="status" aria-live="polite" aria-atomic="true">
                    <span class="hk-redirect-spinner" aria-hidden="true"></span>
                    <p class="hk-redirect-message"></p>
                    <span class="hk-redirect-progress" aria-hidden="true"></span>
                </div>
            `;
            document.body.appendChild(overlay);
        }

        const messageNode = overlay.querySelector('.hk-redirect-message');
        if (messageNode) {
            messageNode.textContent = message;
        }

        document.body.classList.add('hk-is-redirecting');
        requestAnimationFrame(() => overlay.classList.add('is-visible'));
    }

    // KAN-264: diferencia entre el reloj del servidor y el del navegador, para
    // que la cuenta atrás de la reserva no dependa de la hora del dispositivo.
    // Sale de la cabecera Date de las respuestas de admin-ajax, que solo trae
    // segundos: por debajo de 3 s se ignora para que el contador no salte.
    let serverClockOffsetMs = 0;

    function syncServerClock(response) {
        const dateHeader = response && response.headers ? response.headers.get('Date') : '';
        const serverTime = dateHeader ? Date.parse(dateHeader) : Number.NaN;
        if (!Number.isFinite(serverTime)) {
            return;
        }
        const offset = serverTime - Date.now();
        serverClockOffsetMs = Math.abs(offset) > 3000 ? offset : 0;
    }

    function serverNowMs() {
        return Date.now() + serverClockOffsetMs;
    }

    function formatCountdown(totalSeconds) {
        const safeSeconds = Math.max(0, Math.floor(totalSeconds));
        const hours = Math.floor(safeSeconds / 3600);
        const minutes = Math.floor((safeSeconds % 3600) / 60);
        const seconds = safeSeconds % 60;
        const minutesAndSeconds = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
        return hours > 0 ? `${hours}:${minutesAndSeconds}` : minutesAndSeconds;
    }

    function ensureReservationModalStyles() {
        if (document.getElementById(reservationStylesId)) {
            return;
        }
        const style = document.createElement('style');
        style.id = reservationStylesId;
        style.textContent = `
            body.hk-is-redirecting {
                overflow: hidden;
            }
            #${reservationModalId} {
                position: fixed;
                inset: 0;
                z-index: 10000;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 16px;
                background: rgba(15, 23, 42, 0.55);
                backdrop-filter: blur(2px);
            }
            #${reservationModalId},
            #${reservationModalId} *,
            #${reservationModalId} *::before,
            #${reservationModalId} *::after {
                box-sizing: border-box;
            }
            #${reservationModalId} .hk-reservation-card {
                width: min(380px, 100%);
                max-height: calc(100vh - 32px);
                overflow: auto;
                padding: 24px 22px 20px;
                border-radius: 12px;
                background: #ffffff;
                color: #16303d;
                text-align: center;
                box-shadow: 0 18px 44px rgba(15, 23, 42, 0.25);
                outline: none;
            }
            #${reservationModalId} .hk-reservation-title {
                margin: 0 0 6px;
                font-size: 20px;
                line-height: 1.25;
                font-weight: 800;
                color: #16303d;
            }
            #${reservationModalId} .hk-reservation-intro {
                margin: 0 0 16px;
                font-size: 15px;
                line-height: 1.45;
            }
            #${reservationModalId} .hk-reservation-timer {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 2px;
                margin: 0 0 10px;
                padding: 12px 16px;
                border-radius: 10px;
                background: #eef7f9;
            }
            #${reservationModalId} .hk-reservation-timer-label {
                font-size: 12px;
                font-weight: 700;
                letter-spacing: 0.04em;
                text-transform: uppercase;
                color: #4a6572;
            }
            #${reservationModalId} .hk-reservation-timer-value {
                font-size: 40px;
                line-height: 1.1;
                font-weight: 800;
                font-variant-numeric: tabular-nums;
                color: #16303d;
            }
            #${reservationModalId} .hk-reservation-timer.is-urgent {
                background: #fff4e5;
            }
            #${reservationModalId} .hk-reservation-timer.is-urgent .hk-reservation-timer-value {
                color: #b54708;
            }
            #${reservationModalId} .hk-reservation-timer.is-expired {
                background: #fdecec;
            }
            #${reservationModalId} .hk-reservation-timer.is-expired .hk-reservation-timer-value {
                color: #b42318;
            }
            #${reservationModalId} .hk-reservation-deadline {
                margin: 0 0 16px;
                font-size: 14px;
                line-height: 1.45;
                color: #4a6572;
            }
            #${reservationModalId} .hk-reservation-status {
                margin: 0 0 12px;
                font-size: 14px;
                line-height: 1.45;
                font-weight: 700;
                color: #b42318;
            }
            #${reservationModalId} .hk-reservation-status:empty,
            #${reservationModalId} .hk-reservation-deadline:empty {
                display: none;
            }
            #${reservationModalId} .hk-reservation-pay {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                width: 100%;
                min-height: 48px;
                padding: 12px 18px;
                border: 0;
                border-radius: 999px;
                background: #00ccd9;
                color: #16303d;
                font-size: 16px;
                font-weight: 800;
                line-height: 1.2;
                cursor: pointer;
            }
            #${reservationModalId} .hk-reservation-pay:hover:not(:disabled) {
                background: #00b8c4;
            }
            #${reservationModalId} .hk-reservation-pay:focus-visible,
            #${reservationModalId} .hk-reservation-secondary:focus-visible {
                outline: 3px solid #16303d;
                outline-offset: 2px;
            }
            #${reservationModalId} .hk-reservation-pay:disabled {
                cursor: progress;
                opacity: 0.75;
            }
            #${reservationModalId} .hk-reservation-pay.is-loading::before {
                content: "";
                width: 16px;
                height: 16px;
                border-radius: 999px;
                border: 2px solid rgba(22, 48, 61, 0.25);
                border-top-color: #16303d;
                animation: hk-reservation-spin 0.8s linear infinite;
            }
            #${reservationModalId} .hk-reservation-secondary {
                display: inline-block;
                margin-top: 14px;
                font-size: 14px;
                font-weight: 700;
                color: #16303d;
                text-decoration: underline;
            }
            #${reservationModalId} [hidden] {
                display: none !important;
            }
            @keyframes hk-reservation-spin {
                to { transform: rotate(360deg); }
            }
            @media (prefers-reduced-motion: reduce) {
                #${reservationModalId} .hk-reservation-pay.is-loading::before {
                    animation: none;
                }
            }
        `;
        document.head.appendChild(style);
    }

    // KAN-264: con la plaza Reservada el formulario no salta solo al pago. El
    // modal cuenta el tiempo que queda y el botón «Pagar» se activa cuando
    // Salesforce tiene el enlace. Al acabarse el tiempo, la plaza se libera.
    function openReservationCheckoutModal(options = {}) {
        const texts = suscriptionsData?.text || {};
        const text = (key, fallback) => String(texts[key] || fallback);
        const track = typeof options.track === 'function' ? options.track : () => {};
        const profileUrl = String(options.profileUrl || '');
        const restartUrl = String(options.restartUrl || window.location.href);

        ensureReservationModalStyles();
        const overlay = document.getElementById(redirectOverlayId);
        if (overlay) {
            overlay.classList.remove('is-visible');
        }
        document.getElementById(reservationModalId)?.remove();

        const modal = document.createElement('div');
        modal.id = reservationModalId;
        modal.innerHTML = `
            <div class="hk-reservation-card" role="dialog" aria-modal="true" aria-labelledby="hk-reservation-title" aria-describedby="hk-reservation-intro" tabindex="-1">
                <h2 class="hk-reservation-title" id="hk-reservation-title"></h2>
                <p class="hk-reservation-intro" id="hk-reservation-intro"></p>
                <div class="hk-reservation-timer">
                    <span class="hk-reservation-timer-label"></span>
                    <span class="hk-reservation-timer-value" role="timer" aria-atomic="true">--:--</span>
                </div>
                <p class="hk-reservation-deadline"></p>
                <p class="hk-reservation-status" role="status" aria-live="polite"></p>
                <button type="button" class="hk-reservation-pay"></button>
                <a class="hk-reservation-secondary" hidden></a>
            </div>
        `;
        document.body.appendChild(modal);
        document.body.classList.add('hk-is-redirecting');

        const card = modal.querySelector('.hk-reservation-card');
        const titleNode = modal.querySelector('.hk-reservation-title');
        const introNode = modal.querySelector('.hk-reservation-intro');
        const timerNode = modal.querySelector('.hk-reservation-timer');
        const timerLabelNode = modal.querySelector('.hk-reservation-timer-label');
        const timerValueNode = modal.querySelector('.hk-reservation-timer-value');
        const deadlineNode = modal.querySelector('.hk-reservation-deadline');
        const statusNode = modal.querySelector('.hk-reservation-status');
        const primaryButton = modal.querySelector('.hk-reservation-pay');
        const secondaryLink = modal.querySelector('.hk-reservation-secondary');

        // pending: esperando el enlace · ready: se puede pagar ·
        // unavailable: el enlace no ha llegado · expired: plaza liberada.
        let state = 'pending';
        let expiresAtMs = 0;
        let paymentUrl = '';
        let retryHandler = null;
        let timerId = 0;

        const secondsLeft = () => (expiresAtMs > 0 ? Math.max(0, Math.ceil((expiresAtMs - serverNowMs()) / 1000)) : null);

        const render = () => {
            const isExpired = state === 'expired';
            const remaining = secondsLeft();

            titleNode.textContent = isExpired
                ? text('reservationexpiredtitle', 'La reserva ha caducado')
                : text('reservationtitle', 'Plaza reservada');
            introNode.textContent = isExpired
                ? text('reservationexpired', 'La plaza se ha liberado. Si quedan plazas, puedes volver a inscribirte.')
                : text('reservationintro', 'Completa el primer pago para confirmar tu plaza.');
            timerLabelNode.textContent = text('reservationtimer', 'Tiempo para pagar');
            timerValueNode.textContent = remaining === null ? '--:--' : formatCountdown(remaining);
            timerNode.classList.toggle('is-expired', isExpired);
            timerNode.classList.toggle('is-urgent', !isExpired && remaining !== null && remaining <= 60);

            const deadlineLabel = !isExpired && expiresAtMs > 0 ? formatReservationTime(Math.floor(expiresAtMs / 1000)) : '';
            deadlineNode.textContent = deadlineLabel
                ? text('reservationdeadline', '¡Date prisa, que el tiempo vuela! Si a las %s la reserva no está confirmada, se cancelará.').replace('%s', deadlineLabel)
                : '';
            statusNode.textContent = state === 'unavailable'
                ? text('reservationlinkfailed', 'No hemos podido preparar el enlace de pago.')
                : '';

            primaryButton.hidden = false;
            primaryButton.disabled = state === 'pending';
            primaryButton.classList.toggle('is-loading', state === 'pending');
            if (isExpired) {
                primaryButton.textContent = text('reservationrestart', 'Volver a inscribirme');
            } else if (state === 'ready') {
                primaryButton.textContent = text('reservationpay', 'Pagar reserva');
            } else if (state === 'pending') {
                primaryButton.textContent = text('reservationpreparing', 'Preparando el pago…');
            } else if (retryHandler) {
                primaryButton.textContent = text('reservationretry', 'Reintentar');
            } else if (profileUrl) {
                primaryButton.textContent = text('reservationgotoprofile', 'Pagar desde Mi perfil');
            } else {
                primaryButton.hidden = true;
            }

            // El enlace a Mi perfil sobra si ya es la acción principal.
            const primaryGoesToProfile = state === 'unavailable' && !retryHandler;
            secondaryLink.hidden = isExpired || !profileUrl || primaryGoesToProfile;
            if (!secondaryLink.hidden) {
                secondaryLink.href = profileUrl;
                secondaryLink.textContent = text('reservationpaylater', 'Pagar más tarde desde Mi perfil');
            }
        };

        const expire = () => {
            if (state === 'expired') {
                return;
            }
            state = 'expired';
            window.clearInterval(timerId);
            track('activity_reservation_expired', {});
            render();
        };

        const tick = () => {
            if (state !== 'expired' && expiresAtMs > 0 && expiresAtMs <= serverNowMs()) {
                expire();
                return;
            }
            render();
        };

        primaryButton.addEventListener('click', () => {
            if (state === 'expired') {
                window.location.assign(restartUrl);
                return;
            }
            if (state === 'ready' && paymentUrl) {
                const paymentContext = { payment_flow: 'reservation', seconds_left: secondsLeft() ?? '' };
                if (typeof window.hkGa4TrackPaymentStarted === 'function') {
                    window.hkGa4TrackPaymentStarted({ comp_core: paymentContext });
                }
                window.location.assign(paymentUrl);
                return;
            }
            if (state === 'unavailable') {
                if (retryHandler) {
                    retryHandler();
                } else if (profileUrl) {
                    window.location.assign(profileUrl);
                }
            }
        });

        // Modal sin cierre: el foco no sale de la tarjeta.
        modal.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab') {
                return;
            }
            const focusable = [primaryButton, secondaryLink].filter((node) => !node.hidden && !node.disabled);
            if (focusable.length === 0) {
                event.preventDefault();
                card.focus();
                return;
            }
            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && (document.activeElement === first || document.activeElement === card)) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        });

        // Al volver con «Atrás» desde el checkout, la página sale de la caché
        // del navegador con el contador parado: se recalcula al momento.
        window.addEventListener('pageshow', tick);

        const controller = {
            setExpiry(unixSeconds) {
                const seconds = Number.parseInt(unixSeconds, 10);
                if (!Number.isFinite(seconds) || seconds <= 0 || expiresAtMs > 0) {
                    return;
                }
                expiresAtMs = seconds * 1000;
                tick();
            },
            setPending() {
                if (state === 'expired') {
                    return;
                }
                state = 'pending';
                render();
            },
            setPaymentUrl(url) {
                if (state === 'expired' || !url) {
                    return;
                }
                paymentUrl = url;
                state = 'ready';
                render();
                primaryButton.focus();
            },
            setUnavailable(onRetry = null) {
                if (state === 'expired') {
                    return;
                }
                state = 'unavailable';
                retryHandler = typeof onRetry === 'function' ? onRetry : null;
                track('activity_reservation_link_failed', { seconds_left: secondsLeft() ?? '' });
                render();
            },
            expire,
        };

        controller.setExpiry(options.expiresAtUnixSeconds);
        render();
        timerId = window.setInterval(tick, 1000);
        track('activity_reservation_view', { seconds_left: secondsLeft() ?? '' });
        card.focus();

        return controller;
    }

    function updateExtras() {
        if (!selectTipo) {
            return;
        }
        const selectedPay = selectTipo.value; // "Individual" o "Pack familia"

        extraCheckboxBlocks.forEach(block => {
            const scopedPay = String(block.dataset.pay || '');
            const isActive = scopedPay === '' || scopedPay === selectedPay;
            const inputs = block.querySelectorAll('input[type="checkbox"]');

            // Mostrar / ocultar bloque
            block.style.display = isActive ? '' : 'none';

            inputs.forEach(input => {
                // Si no es del tipo seleccionado, no se envía
                input.disabled = !isActive;

                // Si quieres que al cambiar de tipo se desmarquen:
                if (!isActive) {
                    input.checked = false;
                }
            });
        });
    }

    if (selectTipo) {
        selectTipo.addEventListener('change', updateExtras);
        updateExtras(); // estado inicial al cargar
    }


    const form = document.getElementById('register-activity-form');
    if (!form) return;

    const normalizeLookupValue = (value) => {
        if (typeof value !== 'string') {
            return '';
        }
        return value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
    };

    const isCardPaymentMethod = (value) => {
        const normalized = normalizeLookupValue(String(value || ''));
        return normalized === 'tarjeta' || normalized === 'card' || normalized === 'paymatico';
    };

    const isPendingConfirmationStatus = (value) => {
        const normalized = normalizeLookupValue(String(value || ''));
        if (!normalized) {
            return false;
        }

        return normalized === 'en espera'
            || normalized === 'waitlist'
            || normalized === 'lista espera'
            || normalized === 'lista de espera'
            || normalized.startsWith('solicitad')
            || normalized.includes('wait')
            || normalized.includes('espera')
            || (
                normalized.includes('pendiente')
                && (
                    normalized.includes('confirm')
                    || normalized.includes('plaza')
                )
            )
            || (
                normalized.includes('pending')
                && (
                    normalized.includes('confirm')
                    || normalized.includes('seat')
                )
            );
    };

    const isConfirmedEnrollmentStatus = (value) => {
        const normalized = normalizeLookupValue(String(value || ''));
        if (!normalized) {
            return false;
        }

        return normalized.startsWith('confirmad')
            || normalized.startsWith('completad')
            || normalized.includes('confirmed')
            || normalized.includes('completed');
    };

    // KAN-264: «Reservada» retiene la plaza mientras se paga el primer pago y
    // abre el checkout igual que una Confirmada.
    const isReservedEnrollmentStatus = (value) => {
        const normalized = normalizeLookupValue(String(value || ''));
        if (!normalized) {
            return false;
        }

        return normalized.startsWith('reservad') || normalized.includes('reserved');
    };

    // Hora límite de la reserva en la hora local del navegador. Vacía si no
    // hay fecha o si ya ha pasado.
    const formatReservationTime = (unixSeconds) => {
        const seconds = Number.parseInt(unixSeconds, 10);
        if (!Number.isFinite(seconds) || seconds <= 0) {
            return '';
        }

        const date = new Date(seconds * 1000);
        if (Number.isNaN(date.getTime()) || date.getTime() <= serverNowMs()) {
            return '';
        }

        try {
            return date.toLocaleTimeString(document.documentElement.lang || undefined, { hour: '2-digit', minute: '2-digit' });
        } catch (error) {
            return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
        }
    };

    const getInscriptionsRedirectUrl = (resultData = {}) => {
        const rawUrl = (resultData && typeof resultData.redirectUrl === 'string' && resultData.redirectUrl.trim() !== '')
            ? resultData.redirectUrl
            : (suscriptionsData?.urlredirect || window.location.href);
        try {
            const redirectUrl = new URL(rawUrl, window.location.origin);
            redirectUrl.searchParams.set('tab', 'inscriptions');
            redirectUrl.searchParams.set('hk_subpage', 'inscripciones');
            redirectUrl.searchParams.set('hk_refresh', String(Date.now()));
            return redirectUrl.toString();
        } catch (error) {
            return rawUrl;
        }
    };

    const getGuestRedirectUrl = (resultData = {}) => {
        const rawUrl = (resultData && typeof resultData.redirectUrl === 'string' && resultData.redirectUrl.trim() !== '')
            ? resultData.redirectUrl
            : (form.dataset.guestReturnUrl || window.location.href);
        try {
            const redirectUrl = new URL(rawUrl, window.location.origin);
            redirectUrl.searchParams.set('guest_registration', 'ok');
            redirectUrl.searchParams.set('hk_refresh', String(Date.now()));
            return redirectUrl.toString();
        } catch (error) {
            return rawUrl;
        }
    };

    const wait = (ms) => new Promise((resolve) => {
        setTimeout(resolve, ms);
    });

    const fetchJsonWithTimeout = async (url, options = {}, timeoutMs = 3500) => {
        const safeTimeout = Math.max(1000, Number.parseInt(timeoutMs, 10) || 3500);
        if (typeof AbortController === 'undefined') {
            const response = await fetch(url, options);
            syncServerClock(response);
            return response.json();
        }

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => {
            controller.abort();
        }, safeTimeout);

        try {
            const response = await fetch(url, {
                ...options,
                signal: controller.signal,
            });
            syncServerClock(response);
            return await response.json();
        } finally {
            window.clearTimeout(timeoutId);
        }
    };

    const ensureActivityRequestKey = () => {
        const input = form.querySelector('input[name="hk_activity_request_key"]');
        if (input && String(input.value || '').trim() !== '') {
            return String(input.value || '').trim();
        }

        const programId = String(form.querySelector('input[name="ProgramId"]')?.value || 'program').trim() || 'program';
        const contactId = String(form.querySelector('input[name="ContactId"]')?.value || 'user').trim() || 'user';
        const randomPart = (window.crypto && typeof window.crypto.randomUUID === 'function')
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const requestKey = `wp-activity-${programId}-${contactId}-${randomPart}`;
        if (input) {
            input.value = requestKey;
        }
        return requestKey;
    };

    const pollForPaymentLink = async (enrollmentId, paymentLinkToken = '', onPayload = null) => {
        const action = String(suscriptionsData?.paymentLinkAction || '').trim();
        const nonce = String(suscriptionsData?.paymentLinkNonce || '').trim();
        if (!action || !nonce || !enrollmentId) {
            return '';
        }

        const pollInterval = Math.max(500, Number.parseInt(suscriptionsData?.paymentLinkPollMs, 10) || 1800);
        const maxAttempts = Math.max(1, Number.parseInt(suscriptionsData?.paymentLinkMaxAttempts, 10) || 8);
        const requestTimeout = Math.max(1000, Number.parseInt(suscriptionsData?.paymentLinkRequestTimeoutMs, 10) || 3500);
        const totalTimeout = Math.max(5000, Number.parseInt(suscriptionsData?.paymentLinkTotalTimeoutMs, 10) || 18000);
        const startedAt = Date.now();

        for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
            const elapsed = Date.now() - startedAt;
            const remaining = totalTimeout - elapsed;
            if (remaining <= 0) {
                return '';
            }

            try {
                const pendingPaymentForm = new FormData();
                pendingPaymentForm.append('action', action);
                pendingPaymentForm.append('nonce', nonce);
                pendingPaymentForm.append('enrollmentId', enrollmentId);
                if (paymentLinkToken) {
                    pendingPaymentForm.append('paymentLinkToken', paymentLinkToken);
                }

                const payload = await fetchJsonWithTimeout(
                    suscriptionsData.ajax_url,
                    {
                        method: 'POST',
                        body: pendingPaymentForm,
                    },
                    Math.min(requestTimeout, remaining)
                );

                if (payload?.success) {
                    if (typeof onPayload === 'function') {
                        onPayload(payload?.data || {});
                    }
                    const paymentUrl = String(payload?.data?.paymentUrl || '').trim();
                    if (paymentUrl) {
                        return paymentUrl;
                    }

                    if (payload?.data?.terminal) {
                        return '';
                    }
                } else if (payload?.data?.stopPolling) {
                    return '';
                }
            } catch (error) {
                // Ignore transient polling errors and keep trying until maxAttempts.
            }

            if (attempt < maxAttempts - 1) {
                const elapsedAfterAttempt = Date.now() - startedAt;
                const remainingAfterAttempt = totalTimeout - elapsedAfterAttempt;
                if (remainingAfterAttempt <= 0) {
                    return '';
                }
                await wait(Math.min(pollInterval, remainingAfterAttempt));
            }
        }

        return '';
    };

    const familySelect = form.querySelector('#family_members');
    const familyImageRightsPanel = form.querySelector('[data-family-image-rights-panel="1"]');
    const updateLegacyFamilyImageRights = () => {
        if (!familyImageRightsPanel) {
            return;
        }

        const selectedFamilyIds = new Set(
            Array.from(familySelect?.selectedOptions || [])
                .map((option) => String(option.value || '').trim())
                .filter((value) => value !== '')
        );
        let hasSelectedFamilyMembers = false;

        familyImageRightsPanel.querySelectorAll('[data-family-image-rights-card]').forEach((card) => {
            const memberId = String(card.dataset.familyImageRightsCard || '').trim();
            const selected = memberId !== '' && selectedFamilyIds.has(memberId);
            card.hidden = !selected;
            card.setAttribute('aria-hidden', selected ? 'false' : 'true');
            if (selected) {
                hasSelectedFamilyMembers = true;
            }

            card.querySelectorAll('input[type="checkbox"][data-family-image-rights-input="1"]').forEach((input) => {
                input.disabled = !selected;
                input.required = selected;
                input.setAttribute('aria-required', selected ? 'true' : 'false');
                if (!selected) {
                    input.checked = false;
                }
            });
        });

        familyImageRightsPanel.hidden = !hasSelectedFamilyMembers;
        familyImageRightsPanel.setAttribute('aria-hidden', hasSelectedFamilyMembers ? 'false' : 'true');
    };
    if (familySelect) {
        const familyWrapper = familySelect.closest('.activity-input-family-members');
        const hasFamilyOptions = Array.from(familySelect.options || []).some((option) => String(option.value || '').trim() !== '');
        if (!hasFamilyOptions && familyWrapper) {
            familySelect.disabled = true;
            familyWrapper.style.display = 'none';
        }
        familySelect.addEventListener('change', updateLegacyFamilyImageRights);

        // Pre-selección post-reload: tras añadir o mergear un familiar desde
        // el modal, reloadRegistration() recarga la página y el form vuelve
        // a renderizarse sin opciones marcadas. Antes del reload guardamos
        // los memberIds pendientes en sessionStorage; al cargar los
        // recuperamos y los marcamos como seleccionados aquí. Sin esto, el
        // responsable tiene que reabrir el modal y marcarlos manualmente.
        try {
            const pendingRaw = sessionStorage.getItem('hk_family_pending_select');
            if (pendingRaw) {
                const pendingIds = JSON.parse(pendingRaw);
                if (Array.isArray(pendingIds) && pendingIds.length > 0) {
                    const wanted = new Set(pendingIds.map((id) => String(id || '').trim()).filter((id) => id !== ''));
                    let changed = false;
                    Array.from(familySelect.options || []).forEach((option) => {
                        if (wanted.has(String(option.value || '').trim()) && !option.selected) {
                            option.selected = true;
                            changed = true;
                        }
                    });
                    if (changed) {
                        familySelect.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                sessionStorage.removeItem('hk_family_pending_select');
            }
        } catch (error) {
            // sessionStorage puede fallar en modo privado de Safari, etc.
            // Es un nice-to-have, no bloqueamos el flujo del modal.
        }
    }
    updateLegacyFamilyImageRights();

    const familyHelperNotice = form.querySelector('.hk-family-helper-notice');
    if (familyHelperNotice) {
        const dismissButton = familyHelperNotice.querySelector('.hk-family-helper-dismiss');
        const openButton = familyHelperNotice.querySelector('.hk-family-helper-open');
        const closeIconSvg = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 7L17 17M17 7L7 17" /></svg>';
        const notifyFamilyMembersUpdated = () => {
            try {
                localStorage.setItem(familyStorageUpdateKey, String(Date.now()));
            } catch (error) {
                // localStorage can be blocked in some contexts.
            }
        };
        const closeFamilyModal = () => {
            const modal = document.getElementById(familyModalId);
            if (!modal) {
                return;
            }
            modal.classList.remove('is-visible');
            document.body.classList.remove('hk-family-modal-open');
            const modalBody = modal.querySelector('.hk-family-modal__body');
            if (modalBody) {
                modalBody.replaceChildren();
            }
            document.dispatchEvent(new CustomEvent('hk:family-modal-closed'));
        };
        const focusFamilyPanelNode = (node) => {
            if (!node || typeof node.scrollIntoView !== 'function') {
                return;
            }
            requestAnimationFrame(() => {
                try {
                    node.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                } catch (error) {
                    node.scrollIntoView();
                }
            });
        };
        const showFamilyError = (manager, message) => {
            if (!manager) {
                return;
            }

            const errorNotice = manager.querySelector('#error-notice');
            const errorMessage = manager.querySelector('#error-notice-msg');
            if (!errorNotice) {
                return;
            }

            if (errorMessage) {
                errorMessage.textContent = String(message || '').trim();
            }

            errorNotice.hidden = false;
            errorNotice.style.display = 'flex';
            focusFamilyPanelNode(errorNotice);
        };
        const hideFamilyError = (manager) => {
            if (!manager) {
                return;
            }

            const errorNotice = manager.querySelector('#error-notice');
            if (!errorNotice) {
                return;
            }

            errorNotice.hidden = true;
            errorNotice.style.display = 'none';
        };
        const showFamilyConfirm = (manager, message, yesLabel, noLabel, onAccept, onCancel) => {
            if (!manager) { return; }
            // El confirm se ancla cerca del botón "Procesando…" para que la
            // decisión quede pegada a la acción. Si lo dejásemos arriba (en
            // #error-notice) el responsable tendría que volver a hacer scroll
            // para ver dónde estaba el botón submit.
            const formNode = manager.querySelector('#family-form');
            const actionsRow = manager.querySelector('.hk-family-modal-manager__actions') || manager.querySelector('#submit-family')?.parentElement || null;
            if (!formNode || !actionsRow) {
                // Fallback al comportamiento anterior si el form no tiene la
                // estructura esperada (no debería pasar, pero por defensa).
                if (typeof onCancel === 'function') { onCancel(); }
                return;
            }

            let confirmHost = manager.querySelector('.hk-family-bottom-confirm');
            if (!confirmHost) {
                confirmHost = document.createElement('div');
                confirmHost.className = 'hk-family-bottom-confirm hk-family-notice--confirm';
                actionsRow.parentNode.insertBefore(confirmHost, actionsRow);
            }

            confirmHost.innerHTML = '';
            confirmHost.hidden = false;
            confirmHost.style.display = 'flex';

            const messageNode = document.createElement('p');
            messageNode.className = 'hk-family-bottom-confirm__msg';
            messageNode.textContent = String(message || '').trim();
            confirmHost.appendChild(messageNode);

            const actions = document.createElement('div');
            actions.className = 'hk-family-confirm-actions';

            const acceptBtn = document.createElement('button');
            acceptBtn.type = 'button';
            acceptBtn.className = 'button button-primary hk-family-confirm-actions__accept';
            acceptBtn.textContent = yesLabel || 'Sí';

            const cancelBtn = document.createElement('button');
            cancelBtn.type = 'button';
            cancelBtn.className = 'button hk-family-confirm-actions__cancel';
            cancelBtn.textContent = noLabel || 'No';

            actions.appendChild(acceptBtn);
            actions.appendChild(cancelBtn);
            confirmHost.appendChild(actions);

            // Scroll suave al confirm (que está justo encima del submit).
            try { confirmHost.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
            focusFamilyPanelNode(acceptBtn);

            const cleanup = () => {
                confirmHost.innerHTML = '';
                confirmHost.hidden = true;
                confirmHost.style.display = 'none';
            };

            cancelBtn.addEventListener('click', () => {
                cleanup();
                if (typeof onCancel === 'function') { onCancel(); }
            });
            acceptBtn.addEventListener('click', () => {
                cleanup();
                if (typeof onAccept === 'function') { onAccept(); }
            });
        };
        const showFamilyPendingNotice = (manager, message, closeLabel, onClose) => {
            if (!manager) { return; }
            const actionsRow = manager.querySelector('.hk-family-modal-manager__actions') || manager.querySelector('#submit-family')?.parentElement || null;
            if (!actionsRow) {
                if (typeof onClose === 'function') { onClose(); }
                return;
            }

            let host = manager.querySelector('.hk-family-bottom-confirm');
            if (!host) {
                host = document.createElement('div');
                host.className = 'hk-family-bottom-confirm hk-family-notice--confirm';
                actionsRow.parentNode.insertBefore(host, actionsRow);
            }
            host.innerHTML = '';
            host.hidden = false;
            host.style.display = 'flex';

            const messageNode = document.createElement('p');
            messageNode.className = 'hk-family-bottom-confirm__msg';
            messageNode.textContent = String(message || '').trim();
            host.appendChild(messageNode);

            const closeButton = document.createElement('button');
            closeButton.type = 'button';
            closeButton.className = 'button button-primary hk-family-confirm-actions__accept';
            closeButton.textContent = closeLabel || 'Close';
            host.appendChild(closeButton);
            focusFamilyPanelNode(host);

            closeButton.addEventListener('click', () => {
                host.innerHTML = '';
                host.hidden = true;
                host.style.display = 'none';
                if (typeof onClose === 'function') { onClose(); }
            });
        };
        const bindFamilyManager = (modal, manager) => {
            if (!manager) {
                return;
            }

            const addTitle = String(manager.dataset.addTitle || '').trim() || 'Add family member';
            const editTitle = String(manager.dataset.editTitle || '').trim() || 'Edit family member';
            const addSubmit = String(manager.dataset.addSubmit || '').trim() || 'Save family member';
            const editSubmit = String(manager.dataset.editSubmit || '').trim() || 'Save changes';
            const cancelEditText = String(manager.dataset.cancelEdit || '').trim() || 'Cancel editing';
            const deleteConfirm = String(manager.dataset.deleteConfirm || '').trim() || 'Are you sure you want to delete this family member?';
            const processingText = String(manager.dataset.processing || '').trim() || 'Processing...';
            const saveErrorText = String(manager.dataset.saveError || '').trim() || 'An error occurred while saving this family member.';
            const deleteErrorText = String(manager.dataset.deleteError || '').trim() || 'An error occurred while deleting this family member.';
            const changeErrorText = String(manager.dataset.changeError || '').trim() || 'An error occurred while attaching the existing family member.';
            const yesText = String(manager.dataset.familyYes || '').trim() || 'Yes';
            const noText = String(manager.dataset.familyNo || '').trim() || 'No';
            const adultHintPending = String(manager.dataset.adultHintPending || '').trim();
            const adultHintAdult = String(manager.dataset.adultHintAdult || '').trim();
            const adultHintMinor = String(manager.dataset.adultHintMinor || '').trim();
            const selectText = String(manager.dataset.selectMember || '').trim() || 'Select';
            const selectedText = String(manager.dataset.selectedMember || '').trim() || 'Selected';
            const familyRoleRequiredText = String(manager.dataset.familyRoleRequired || '').trim() || 'Selecciona la relación familiar antes de guardar.';
            const initialMode = String(manager.dataset.initialMode || 'list').trim();
            const localRegistrationMode = String(manager.dataset.localRegistrationMode || '') === '1';
            const localAllowsMinors = String(manager.dataset.localAllowMinors || '') === '1';
            const localExternalMinorAllowed = String(manager.dataset.externalMinorAllowed || '') === '1';
            const externalMinorRole = String(manager.dataset.externalMinorRole || 'Menor de fuera de la familia').trim() || 'Menor de fuera de la familia';
            const externalMinorNoticeText = String(manager.dataset.externalMinorNotice || '').trim() || 'Menor de fuera de la familia. Se revisará al asignar plaza.';
            const externalMinorAgeErrorText = String(manager.dataset.externalMinorAgeError || '').trim() || 'Este rol solo se puede usar con menores de edad al inicio de la actividad.';
            const localProgramStartDate = String(manager.dataset.programStartDate || '').trim();
            const localMaxAdults = Math.min(2, Math.max(1, Number.parseInt(manager.dataset.familyMaxAdults || '2', 10) || 2));
            const localAllowedRolesRaw = (() => {
                try {
                    const parsed = JSON.parse(String(manager.dataset.familyAllowedRoles || '[]'));
                    return Array.isArray(parsed) ? parsed : [];
                } catch (error) {
                    return [];
                }
            })();
            const normalizeManagerFamilyText = (value) => String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toLowerCase()
                .replace(/[^a-z0-9]+/g, ' ')
                .trim();
            const isExternalMinorRole = (rawRole) => {
                const normalized = normalizeManagerFamilyText(rawRole);
                if (!normalized) {
                    return false;
                }
                const compact = normalized.replace(/\s+/g, '');
                return [
                    'menordefueradelafamilia',
                    'menorfuerafamilia',
                    'menorexterno',
                    'minorexterno',
                    'externalminor',
                    'nonfamilyminor',
                    'outsidefamilyminor',
                ].includes(compact)
                    || (normalized.includes('menor') && normalized.includes('fuera') && normalized.includes('familia'));
            };
            const normalizeManagerFamilyRole = (rawRole) => {
                const normalized = normalizeManagerFamilyText(rawRole);
                if (isExternalMinorRole(normalized)) {
                    return externalMinorRole;
                }
                if (/\b(hijo|hija|child|son|daughter|dependent|dependiente|menor|minor|nino|nina|bebe|baby)\b/.test(normalized)) {
                    return 'Hijo';
                }
                if (/\b(conyuge|conjuge|spouse|marido|mujer|pareja|partner)\b/.test(normalized)) {
                    return 'Cónyuge';
                }
                if (/\b(acompanante|companion|guest|invitado|adult companion)\b/.test(normalized)) {
                    return 'Acompañante';
                }
                if (/\b(responsable|titular|owner|responsible|payer)\b/.test(normalized)) {
                    return 'Responsable';
                }
                return '';
            };

            const form = manager.querySelector('#family-form');
            const formPanel = manager.querySelector('#family-member-form-panel');
            if (!form || !formPanel) {
                return;
            }
            // El form contiene un <input name="action"> que sombrea la propiedad
            // form.action del HTMLFormElement: si lees form.action, el navegador
            // devuelve el input en lugar de la URL del atributo. Convertido a
            // string en fetch() sale "[object HTMLInputElement]" → POST a esa
            // ruta → 404. Resolvemos la URL una sola vez vía getAttribute.
            const formActionUrl = form.getAttribute('action') || window.location.href;

            const formTitle = manager.querySelector('.hk-family-modal-manager__form-title');
            const submitButton = manager.querySelector('#submit-family');
            const cancelEditButton = manager.querySelector('#family-cancel-edit');
            const deleteEditButton = manager.querySelector('#family-delete-edit');
            const addButton = manager.querySelector('[data-family-form-open="1"]');
            const memberIdInput = manager.querySelector('#family-member-id');
            const birthdateInput = manager.querySelector('#Birthdate');
            const genderInput = manager.querySelector('#family-member-gender');
            const nifInput = manager.querySelector('#HKN_NIF__c');
            const ageGroupInput = manager.querySelector('#family-member-age-group');
            const phonePrefixInput = manager.querySelector('#family-member-phone-prefix');
            const phoneInput = manager.querySelector('#family-member-phone');
            const emailInput = manager.querySelector('#family-member-email');
            const emailWrapper = manager.querySelector('#email-wrapper');
            const familyRoleWrapper = manager.querySelector('#family-role-wrapper');
            const familyRoleInput = manager.querySelector('#family-member-family-role');
            const familyRoleSpouseOption = familyRoleInput
                ? Array.from(familyRoleInput.options || []).find((opt) => normalizeManagerFamilyText(opt.value || '') === 'conyuge')
                : null;
            const webAccessToggle = manager.querySelector('#family-new-user-toggle');
            const webAccessValue = manager.querySelector('#family-new-user-value');
            const webAccessState = manager.querySelector('#family-new-user-state');
            const adultFieldsSection = manager.querySelector('#family-adult-fields');
            const adultFieldsHint = manager.querySelector('#family-adult-fields-hint');
            const accountInput = form.querySelector('input[name="AccountId"]');
            const nonceInput = form.querySelector('input[name="_wpnonce"]');
            const actionInput = form.querySelector('input[name="action"]');
            const adultOnlyFields = [nifInput, ageGroupInput, phonePrefixInput, phoneInput].filter(Boolean);
            const familyCards = Array.from(manager.querySelectorAll('.hk-family-modal-member'));
            let familyDeleteInProgress = false;
            if (familyRoleWrapper) {
                familyRoleWrapper.hidden = !localRegistrationMode;
            }
            if (familyRoleInput) {
                familyRoleInput.disabled = !localRegistrationMode;
                familyRoleInput.required = localRegistrationMode;
                familyRoleInput.setAttribute('aria-required', localRegistrationMode ? 'true' : 'false');
                if (!localRegistrationMode) {
                    familyRoleInput.setCustomValidity('');
                }
            }
            const validateFamilyRoleInput = () => {
                if (!localRegistrationMode || !familyRoleInput || familyRoleInput.disabled) {
                    return true;
                }
                const role = normalizeManagerFamilyRole(familyRoleInput.value || '');
                if (role === '') {
                    familyRoleInput.setCustomValidity(familyRoleRequiredText);
                    return false;
                }
                familyRoleInput.setCustomValidity('');
                return true;
            };
            if (familyRoleInput && !familyRoleInput._hkFamilyRoleBound) {
                familyRoleInput.addEventListener('change', validateFamilyRoleInput);
                familyRoleInput.addEventListener('input', validateFamilyRoleInput);
                familyRoleInput._hkFamilyRoleBound = true;
            }
            const parseFamilyJson = (response) => response.text().then((text) => {
                const rawText = String(text || '');
                const trimmedText = rawText.trim();
                if (!trimmedText) {
                    throw new Error(saveErrorText);
                }

                const parseCandidate = (candidate) => {
                    if (!candidate) {
                        return null;
                    }

                    try {
                        const parsed = JSON.parse(candidate);
                        return (parsed && typeof parsed === 'object') ? parsed : null;
                    } catch (error) {
                        return null;
                    }
                };

                let parsed = parseCandidate(trimmedText);
                if (!parsed) {
                    const jsonStart = trimmedText.indexOf('{');
                    const jsonEnd = trimmedText.lastIndexOf('}');
                    if (jsonStart !== -1 && jsonEnd !== -1 && jsonEnd > jsonStart) {
                        parsed = parseCandidate(trimmedText.slice(jsonStart, jsonEnd + 1));
                    }
                }

                if (parsed) {
                    return parsed;
                }

                const plainText = trimmedText
                    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
                    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
                    .replace(/<[^>]+>/g, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();

                if (plainText) {
                    const looksLikeFullHtmlPage = (
                        /<!doctype html|<html[\s>]|Página no encontrada|Page not found/i.test(trimmedText)
                        || plainText.length > 320
                    );

                    if (looksLikeFullHtmlPage) {
                        console.error('Unexpected non-JSON response while managing family members:', rawText);
                        throw new Error(saveErrorText);
                    }

                    throw new Error(plainText);
                }

                throw new Error(saveErrorText);
            });
            const getSelectedFamilyIds = () => new Set(
                Array.from(familySelect?.selectedOptions || [])
                    .map((option) => String(option.value || '').trim())
                    .filter((value) => value !== '')
            );
            const updateCardSelectionState = (card, isSelected) => {
                if (!card) {
                    return;
                }

                const selected = Boolean(isSelected) && String(card.dataset.selectable || '') === '1';
                card.classList.toggle('is-selected', selected);
                card.classList.toggle('hk-family-modal-member--selected', selected);
                card.setAttribute('aria-selected', selected ? 'true' : 'false');

                const selectButton = card.querySelector('[data-family-action="toggle-select"]');
                if (!selectButton) {
                    return;
                }

                selectButton.classList.toggle('is-selected', selected);
                selectButton.setAttribute('aria-pressed', selected ? 'true' : 'false');

                const labelNode = selectButton.querySelector('.hk-family-modal-member__select-label');
                if (labelNode) {
                    labelNode.textContent = selected ? selectedText : selectText;
                }

                const iconNode = selectButton.querySelector('.hk-family-modal-member__select-icon');
                if (iconNode) {
                    iconNode.textContent = selected ? '✓' : '+';
                }
            };
            const syncModalSelectionState = () => {
                const selectedIds = getSelectedFamilyIds();
                familyCards.forEach((card) => {
                    const memberId = String(card.dataset.memberId || '').trim();
                    updateCardSelectionState(card, selectedIds.has(memberId));
                });
            };
            const toggleFamilyCardSelection = (card) => {
                if (!familySelect || !card || String(card.dataset.selectable || '') !== '1') {
                    return;
                }

                const memberId = String(card.dataset.memberId || '').trim();
                if (!memberId) {
                    return;
                }

                const targetOption = Array.from(familySelect.options || []).find((option) => String(option.value || '').trim() === memberId);
                if (!targetOption) {
                    return;
                }

                targetOption.selected = !targetOption.selected;
                familySelect.dispatchEvent(new Event('change', { bubbles: true }));
                syncModalSelectionState();
            };

            const toggleFormPanel = (shouldOpen) => {
                const isOpen = Boolean(shouldOpen);
                formPanel.hidden = !isOpen;
                manager.classList.toggle('is-form-open', isOpen);
                if (isOpen) {
                    requestAnimationFrame(() => {
                        formPanel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
                    });
                }
            };

            const getMemberAge = (rawValue, referenceValue = '') => {
                const normalized = String(rawValue || '').trim();
                if (!normalized) {
                    return null;
                }

                const birthdate = new Date(`${normalized}T00:00:00`);
                if (Number.isNaN(birthdate.getTime())) {
                    return null;
                }

                const referenceDate = String(referenceValue || '').trim()
                    ? new Date(`${String(referenceValue).trim().slice(0, 10)}T00:00:00`)
                    : new Date();
                const today = Number.isNaN(referenceDate.getTime()) ? new Date() : referenceDate;
                let age = today.getFullYear() - birthdate.getFullYear();
                const monthDelta = today.getMonth() - birthdate.getMonth();
                if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < birthdate.getDate())) {
                    age -= 1;
                }

                return age;
            };

            const accessStatusEl = (() => {
                if (!webAccessToggle) return null;
                const existing = manager.querySelector('#family-web-access-status');
                if (existing) return existing;
                const node = document.createElement('p');
                node.id = 'family-web-access-status';
                node.className = 'hk-family-access-status';
                node.hidden = true;
                node.dataset.status = '';
                const accessRow = webAccessToggle.closest('.hk-family-access-row') || webAccessToggle.parentElement;
                if (accessRow && accessRow.parentNode) {
                    accessRow.parentNode.insertBefore(node, accessRow.nextSibling);
                }
                return node;
            })();

            const hideAccessStatus = () => {
                if (!accessStatusEl) return;
                accessStatusEl.hidden = true;
                accessStatusEl.textContent = '';
                accessStatusEl.dataset.status = '';
            };

            const renderAccessStatus = (status, message) => {
                if (!accessStatusEl) return;
                if (!status || !message) {
                    hideAccessStatus();
                    return;
                }
                accessStatusEl.hidden = false;
                accessStatusEl.textContent = message;
                accessStatusEl.dataset.status = status;
            };

            let accessCheckDebounce = null;
            const runExistingAccountCheck = () => {
                if (!webAccessToggle || !emailInput) return;
                const email = String(emailInput.value || '').trim();
                const firstName = String(form.querySelector('#FirstName')?.value || '').trim();
                const lastName = String(form.querySelector('#LastName')?.value || '').trim();
                const birthdate = String(birthdateInput?.value || '').trim();
                const nif = String(form.querySelector('#HKN_NIF__c')?.value || '').trim();
                const hasIdentity = firstName !== '' && lastName !== '' && birthdate !== '';
                const hasValidEmail = email !== '' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                // Lanzamos el check si toggle ON + (hay email válido O NIF
                // O terna identidad completa). Si no, lo ocultamos.
                if (!webAccessToggle.checked || (!hasValidEmail && !hasIdentity && nif === '')) {
                    hideAccessStatus();
                    return;
                }
                const restRoot = (typeof suscriptionsData !== 'undefined' && suscriptionsData && suscriptionsData.rest_url)
                    ? suscriptionsData.rest_url
                    : ((typeof admin !== 'undefined' && admin && admin.rest_url) ? admin.rest_url : '/wp-json/');
                const url = restRoot.replace(/\/$/, '') + '/hk-extras/v1/family/check-web-account';
                const formNonce = nonceInput ? nonceInput.value : '';
                const body = new FormData();
                if (hasValidEmail) body.append('email', email);
                if (firstName) body.append('first_name', firstName);
                if (lastName) body.append('last_name', lastName);
                if (birthdate) body.append('birthdate', birthdate);
                if (nif) body.append('nif', nif);
                body.append('nonce', formNonce);
                renderAccessStatus('checking', 'Comprobando si esta persona ya tiene cuenta…');
                fetch(url, { method: 'POST', credentials: 'same-origin', body })
                    .then((response) => response.json().catch(() => null))
                    .then((data) => {
                        if (!data || typeof data.status !== 'string') {
                            hideAccessStatus();
                            return;
                        }
                        renderAccessStatus(data.status, data.message || '');
                    })
                    .catch(() => hideAccessStatus());
            };
            const queueExistingAccountCheck = () => {
                if (accessCheckDebounce) clearTimeout(accessCheckDebounce);
                accessCheckDebounce = setTimeout(runExistingAccountCheck, 350);
            };

            const updateWebAccess = () => {
                const memberAge = getMemberAge(birthdateInput?.value || '');
                const knowsAge = typeof memberAge === 'number';
                const isAdult = knowsAge && memberAge >= 18;
                // La "cuenta propia en la web" SOLO está disponible para mayores.
                // Para menores forzamos el toggle a false y lo dejamos disabled;
                // el CSS del modal de actividades ya oculta el contenedor cuando
                // data-age-mode='minor', pero el state interno se mantiene
                // consistente: nunca se mandará new_user=yes para un menor.
                if (webAccessToggle && !isAdult && webAccessToggle.checked) {
                    webAccessToggle.checked = false;
                }
                if (webAccessToggle) {
                    webAccessToggle.disabled = !isAdult || webAccessToggle.disabled === true && !!webAccessToggle.dataset.lockedExisting;
                    if (!isAdult) {
                        webAccessToggle.disabled = true;
                    }
                }
                const hasWebAccess = isAdult && !!webAccessToggle?.checked;
                const needsEmail = hasWebAccess || isAdult;

                if (webAccessValue) {
                    webAccessValue.value = hasWebAccess ? 'yes' : 'no';
                }

                if (webAccessState) {
                    webAccessState.textContent = hasWebAccess ? yesText : noText;
                }

                adultOnlyFields.forEach((field) => {
                    field.required = isAdult;
                    field.setAttribute('aria-required', isAdult ? 'true' : 'false');
                });

                if (adultFieldsSection) {
                    adultFieldsSection.dataset.ageMode = knowsAge
                        ? (isAdult ? 'adult' : 'minor')
                        : 'unknown';
                }

                if (adultFieldsHint) {
                    if (!knowsAge) {
                        adultFieldsHint.textContent = adultHintPending;
                    } else if (isAdult) {
                        adultFieldsHint.textContent = adultHintAdult;
                    } else {
                        adultFieldsHint.textContent = adultHintMinor;
                    }
                }

                if (emailWrapper && emailInput) {
                    emailWrapper.hidden = !needsEmail;
                    emailInput.required = needsEmail;
                }

                if (familyRoleInput) {
                    if (familyRoleSpouseOption) {
                        const isEditingMember = String(formPanel?.dataset.editingMemberId || '') !== '';
                        const currentParticipantsContainer = document.querySelector('#hk-registration-participants');
                        const spouseAlreadyAdded = !isEditingMember
                            && !!currentParticipantsContainer
                            && Array.from(currentParticipantsContainer.querySelectorAll('.activity-register-participant'))
                                .some((section) => normalizeManagerFamilyRole(section.dataset.familyRole || '') === 'Cónyuge');
                        if ((knowsAge && !isAdult && localAllowsMinors) || spouseAlreadyAdded) {
                            familyRoleSpouseOption.disabled = true;
                            familyRoleSpouseOption.hidden = true;
                            if (familyRoleInput.value === 'Cónyuge') {
                                familyRoleInput.value = '';
                                delete familyRoleInput.dataset.autoChildRole;
                            } else if (knowsAge && !isAdult && familyRoleInput.value !== 'Hijo' && !isExternalMinorRole(familyRoleInput.value)) {
                                familyRoleInput.value = 'Hijo';
                                familyRoleInput.dataset.autoChildRole = '1';
                            }
                        } else {
                            familyRoleSpouseOption.disabled = false;
                            familyRoleSpouseOption.hidden = false;
                            if (familyRoleInput.dataset.autoChildRole === '1') {
                                familyRoleInput.value = '';
                                delete familyRoleInput.dataset.autoChildRole;
                            }
                        }
                    }
                    validateFamilyRoleInput();
                }

                if (!isAdult || !webAccessToggle?.checked) {
                    hideAccessStatus();
                    return;
                }
                queueExistingAccountCheck();
            };
            if (webAccessToggle && !webAccessToggle._hkAccessChangeBound) {
                webAccessToggle.addEventListener('change', updateWebAccess);
                webAccessToggle._hkAccessChangeBound = true;
            }
            if (emailInput && !emailInput._hkAccessEmailBound) {
                const onEmailChange = () => {
                    if (webAccessToggle?.checked) {
                        queueExistingAccountCheck();
                    }
                };
                emailInput.addEventListener('blur', onEmailChange);
                emailInput.addEventListener('input', onEmailChange);
                emailInput._hkAccessEmailBound = true;
            }
            if (birthdateInput && !birthdateInput._hkAccessAgeBound) {
                birthdateInput.addEventListener('change', updateWebAccess);
                birthdateInput._hkAccessAgeBound = true;
            }

            const setSubmitState = (isProcessing) => {
                if (!submitButton) {
                    return;
                }

                if (!submitButton.dataset.defaultText) {
                    submitButton.dataset.defaultText = submitButton.textContent || '';
                }

                submitButton.disabled = isProcessing;
                submitButton.textContent = isProcessing
                    ? processingText
                    : (submitButton.dataset.defaultText || addSubmit);
            };

            const setMode = (mode, member = null) => {
                const isEditMode = mode === 'edit' && member;
                if (formTitle) {
                    formTitle.textContent = isEditMode ? editTitle : addTitle;
                }

                hideFamilyError(manager);

                if (cancelEditButton) {
                    cancelEditButton.hidden = !isEditMode;
                    cancelEditButton.textContent = cancelEditText;
                }

                if (deleteEditButton) {
                    deleteEditButton.hidden = !isEditMode;
                    deleteEditButton.dataset.memberId = isEditMode ? (member?.dataset.memberId || '') : '';
                }

                if (submitButton) {
                    const targetText = isEditMode ? editSubmit : addSubmit;
                    submitButton.dataset.defaultText = targetText;
                    submitButton.textContent = targetText;
                    submitButton.disabled = false;
                }

                if (actionInput) {
                    actionInput.value = 'sf_register_family_member';
                }

                form.reset();
                if (formPanel) {
                    formPanel.dataset.editingMemberId = isEditMode ? (member?.dataset.memberId || '') : '';
                }
                if (memberIdInput) {
                    memberIdInput.value = isEditMode ? (member.dataset.memberId || '') : '';
                }

                if (webAccessToggle) {
                    webAccessToggle.disabled = false;
                    webAccessToggle.checked = false;
                }

                if (isEditMode && member) {
                    form.querySelector('#FirstName').value = member.dataset.firstName || '';
                    form.querySelector('#LastName').value = member.dataset.lastName || '';
                    birthdateInput.value = member.dataset.birthdate || '';
                    if (genderInput) {
                        genderInput.value = normalizeContactGenderValue(member.dataset.gender || '');
                    }
                    if (nifInput) {
                        nifInput.value = member.dataset.nif || '';
                    }
                    if (ageGroupInput) {
                        ageGroupInput.value = member.dataset.ageGroup || '';
                    }
                    if (phonePrefixInput) {
                        phonePrefixInput.value = member.dataset.phonePrefix || '';
                    }
                    if (phoneInput) {
                        phoneInput.value = member.dataset.phone || '';
                    }
                    if (emailInput) {
                        emailInput.value = member.dataset.email || '';
                    }
                    if (webAccessToggle) {
                        const hasWebAccess = String(member.dataset.webAccess || '') === '1';
                        webAccessToggle.checked = hasWebAccess;
                        webAccessToggle.disabled = hasWebAccess;
                    }
                }

                updateWebAccess();
                toggleFormPanel(true);
            };

            // Guarda en sessionStorage la lista de memberIds que deben quedar
            // pre-seleccionados en #family_members después del reload. La
            // recogida y consumo se hace en el bloque inicial del script
            // (al inicializar familySelect). Acumula con las selecciones
            // previas para no perderlas si el responsable había marcado a
            // otra persona antes de añadir el nuevo familiar.
            const queueFamilyPreselect = (memberId) => {
                if (!memberId) {
                    return;
                }
                try {
                    const existingRaw = sessionStorage.getItem('hk_family_pending_select');
                    const previous = existingRaw ? JSON.parse(existingRaw) : [];
                    const set = new Set(Array.isArray(previous) ? previous.map((id) => String(id || '').trim()) : []);
                    if (familySelect) {
                        Array.from(familySelect.selectedOptions || []).forEach((option) => {
                            const value = String(option.value || '').trim();
                            if (value !== '') {
                                set.add(value);
                            }
                        });
                    }
                    set.add(String(memberId).trim());
                    sessionStorage.setItem('hk_family_pending_select', JSON.stringify(Array.from(set)));
                } catch (error) {
                    // sessionStorage puede fallar; el usuario solo tendrá que
                    // reabrir el modal para marcar al familiar nuevo. No
                    // bloqueamos.
                }
            };

            const reloadRegistration = () => {
                notifyFamilyMembersUpdated();
                closeFamilyModal();
                try {
                    window.location.reload();
                } catch (error) {
                    window.location.href = window.location.href;
                }
            };

            const normalizeFamilyFullNameKey = (firstName, lastName) => {
                const value = `${firstName || ''} ${lastName || ''}`.trim();
                if (!value) {
                    return '';
                }
                return value
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, ' ')
                    .trim();
            };

            const getDuplicateFamilyNameMessage = (firstName, lastName) => {
                const name = `${firstName || ''} ${lastName || ''}`.trim();
                return name
                    ? `Ya existe un miembro de tu familia con el nombre "${name}". Revisa su ficha antes de crear otro familiar.`
                    : 'Ya existe un miembro de tu familia con ese nombre. Revisa su ficha antes de crear otro familiar.';
            };

            const hasExistingFamilyFullName = (firstName, lastName, excludeMemberId = '') => {
                const targetKey = normalizeFamilyFullNameKey(firstName, lastName);
                const excludedId = String(excludeMemberId || '').trim();
                if (!targetKey) {
                    return false;
                }

                return familyCards.some((card) => {
                    const memberId = String(card.dataset.memberId || '').trim();
                    if (!memberId || (excludedId && memberId === excludedId)) {
                        return false;
                    }
                    return normalizeFamilyFullNameKey(card.dataset.firstName || '', card.dataset.lastName || '') === targetKey;
                });
            };

            const deleteFamilyMember = (memberId) => {
                const targetMemberId = String(memberId || '').trim();
                if (!targetMemberId) {
                    return;
                }

                showFamilyConfirm(manager, deleteConfirm, yesText, noText, () => {
                    if (familyDeleteInProgress) {
                        return;
                    }
                    familyDeleteInProgress = true;
                    if (deleteEditButton) {
                        deleteEditButton.disabled = true;
                    }
                    hideFamilyError(manager);
                    const requestData = new FormData();
                    requestData.set('action', 'sf_delete_family_member');
                    requestData.set('memberId', targetMemberId);
                    requestData.set('AccountId', accountInput ? accountInput.value : '');
                    requestData.set('_wpnonce', nonceInput ? nonceInput.value : '');

                    fetch(formActionUrl, {
                        method: 'POST',
                        credentials: 'same-origin',
                        body: requestData,
                    })
                        .then(parseFamilyJson)
                        .then((result) => {
                            if (!result?.success) {
                                throw new Error(result?.data?.message || deleteErrorText);
                            }
                            reloadRegistration();
                        })
                        .catch((error) => {
                            showFamilyError(manager, error?.message || deleteErrorText);
                            familyDeleteInProgress = false;
                            if (deleteEditButton) {
                                deleteEditButton.disabled = false;
                            }
                        });
                });
            };

            const handleChangeFamilyMember = (accountId, memberId, formData) => {
                const requestData = new FormData();
                requestData.set('action', 'sf_change_family_member');
                requestData.set('AccountId', accountId || '');
                requestData.set('memberId', memberId || '');
                requestData.set('nif', String(formData.get('HKN_NIF__c') || '').trim());
                requestData.set('_wpnonce', nonceInput ? nonceInput.value : '');

                ['FirstName', 'LastName', 'Birthdate', 'family-member-email', 'HKN_Gender__c', 'HKN_PrefijoTelefono__c', 'Phone', 'HKN_GrupoEdad__c', 'new_user', 'MailingCountryCode', 'hk_family_role', 'hk_family_role_required'].forEach((fieldName) => {
                    if (formData.has(fieldName)) {
                        requestData.set(fieldName, formData.get(fieldName));
                    }
                });

                return fetch(formActionUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: requestData,
                })
                    .then(parseFamilyJson)
                    .then((result) => {
                        if (!result?.success) {
                            throw new Error(result?.data?.message || changeErrorText);
                        }
                        queueFamilyPreselect(memberId);
                        reloadRegistration();
                    });
            };

            const getLocalParticipantsInput = () => document.querySelector('#register-activity-form input[name="hk_local_registration_participants"]');

            const readLocalParticipants = () => {
                const input = getLocalParticipantsInput();
                if (!input) {
                    return [];
                }

                try {
                    const parsed = JSON.parse(String(input.value || '[]'));
                    return Array.isArray(parsed) ? parsed.filter((item) => item && typeof item === 'object') : [];
                } catch (error) {
                    return [];
                }
            };

            const writeLocalParticipants = (participants) => {
                const input = getLocalParticipantsInput();
                if (input) {
                    input.value = JSON.stringify(participants || []);
                }
            };

            const appendHiddenContactField = (section, name, value, type = 'text') => {
                if (!section || !name || value === undefined || value === null || String(value).trim() === '') {
                    return;
                }

                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                input.value = String(value);
                input.dataset.form = 'Contact';
                input.dataset.type = type;
                section.appendChild(input);
            };

            const getLocalAllowedRoles = () => {
                let roles = localAllowedRolesRaw
                    .map((role) => normalizeManagerFamilyRole(role))
                    .filter((role, index, all) => {
                        if (!role || role === 'Responsable' || all.indexOf(role) !== index) {
                            return false;
                        }
                        return !isExternalMinorRole(role) || localExternalMinorAllowed;
                    });
                if (roles.length === 0) {
                    roles = localAllowsMinors ? ['Cónyuge', 'Hijo'] : ['Cónyuge'];
                }
                if (localRegistrationMode && localAllowsMinors && localExternalMinorAllowed && !roles.some((role) => isExternalMinorRole(role))) {
                    roles.push(externalMinorRole);
                }
                return roles;
            };

            const countCurrentPrimaryAdults = () => {
                if (!participantsContainer) {
                    return 0;
                }
                const sections = participantsContainer.querySelectorAll('.activity-register-participant');
                let count = 0;
                sections.forEach((section) => {
                    if (String(section.dataset.isOwner || '') === '1') {
                        count += 1;
                        return;
                    }
                    const role = normalizeManagerFamilyRole(section.dataset.familyRole || '');
                    if (role !== '' && role !== 'Hijo' && !isExternalMinorRole(role)) {
                        count += 1;
                    }
                });
                return count;
            };

            const countCurrentSpouses = () => {
                if (!participantsContainer) {
                    return 0;
                }
                let count = 0;
                participantsContainer.querySelectorAll('.activity-register-participant').forEach((section) => {
                    if (normalizeManagerFamilyRole(section.dataset.familyRole || '') === 'Cónyuge') {
                        count += 1;
                    }
                });
                return count;
            };

            const addLocalRegistrationParticipant = (formData) => {
                const firstName = String(formData.get('FirstName') || '').trim();
                const lastName = String(formData.get('LastName') || '').trim();
                const birthdate = String(formData.get('Birthdate') || '').trim();
                const email = String(formData.get('family-member-email') || '').trim();
                const gender = normalizeContactGenderValue(formData.get('HKN_Gender__c') || '');
                const documentNumber = String(formData.get('HKN_NIF__c') || '').trim();
                const phonePrefix = String(formData.get('HKN_PrefijoTelefono__c') || '').trim();
                const phone = String(formData.get('Phone') || '').trim();
                const rawRole = String(formData.get('hk_family_role') || '').trim();
                const familyRole = normalizeManagerFamilyRole(rawRole);
                const isExternalMinor = isExternalMinorRole(familyRole);
                const memberAge = getMemberAge(birthdate, localProgramStartDate);
                const isMinor = typeof memberAge === 'number' && memberAge < 18;
                if (!firstName || !lastName) {
                    showFamilyError(manager, saveErrorText);
                    setSubmitState(false);
                    return;
                }
                if (isExternalMinor && (!localRegistrationMode || !localAllowsMinors || !localExternalMinorAllowed)) {
                    showFamilyError(manager, 'Ese rol familiar no está permitido para esta actividad.');
                    setSubmitState(false);
                    return;
                }
                if (isExternalMinor && !isMinor) {
                    showFamilyError(manager, externalMinorAgeErrorText);
                    setSubmitState(false);
                    return;
                }
                const resolvedRole = isExternalMinor ? externalMinorRole : (isMinor ? 'Hijo' : familyRole);
                if (resolvedRole === '') {
                    showFamilyError(manager, familyRoleRequiredText);
                    if (familyRoleInput) {
                        focusFamilyPanelNode(familyRoleInput);
                    }
                    setSubmitState(false);
                    return;
                }
                const allowedRoles = getLocalAllowedRoles();
                if (!allowedRoles.includes(resolvedRole)) {
                    showFamilyError(
                        manager,
                        'Ese rol familiar no está permitido para esta actividad.'
                    );
                    setSubmitState(false);
                    return;
                }
                if (resolvedRole !== 'Hijo' && !isExternalMinor && countCurrentPrimaryAdults() >= localMaxAdults) {
                    showFamilyError(
                        manager,
                        `Esta actividad admite como máximo ${localMaxAdults} adultos principales. Los demás adultos deben quedar como hijos.`
                    );
                    setSubmitState(false);
                    return;
                }
                // Solo puede haber un Cónyuge; más adultos deben ir como Acompañante
                // cuando Salesforce lo permita.
                if (resolvedRole === 'Cónyuge' && countCurrentSpouses() >= 1) {
                    showFamilyError(
                        manager,
                        'Solo puedes añadir a una pareja además de ti.'
                    );
                    setSubmitState(false);
                    return;
                }
                if (!localAllowsMinors) {
                    if (isMinor) {
                        showFamilyError(manager, 'Esta actividad no admite menores.');
                        setSubmitState(false);
                        return;
                    }
                }

                const participant = {
                    participant_key: `local-${Date.now()}-${Math.random().toString(16).slice(2)}`,
                    contact_id: '',
                    firstName,
                    lastName,
                    birthdate,
                    email,
                    gender,
                    documentNumber,
                    nif: documentNumber,
                    phonePrefix,
                    phone,
                    candidate_type: isMinor ? 'Menor' : 'Adulto',
                    candidate_role: resolvedRole,
                    family_role: resolvedRole,
                    familyRole: resolvedRole,
                    is_child: resolvedRole === 'Hijo',
                    is_adult: !isMinor && resolvedRole !== 'Hijo',
                    is_external_minor: isExternalMinor,
                    label: `${firstName} ${lastName}`.trim(),
                };

                const storedParticipants = readLocalParticipants();
                storedParticipants.push(participant);
                writeLocalParticipants(storedParticipants);

                if (participantsContainer && participantTemplate) {
                    const ownerSection = participantsContainer.querySelector('.activity-register-participant[data-is-owner="1"]');
                    const participantSection = createParticipantSection(participant, captureSectionValues(ownerSection), {});
                    if (participantSection) {
                        participantSection.dataset.localParticipant = '1';
                        appendHiddenContactField(participantSection, 'FirstName', firstName);
                        appendHiddenContactField(participantSection, 'LastName', lastName);
                        appendHiddenContactField(participantSection, 'Birthdate', birthdate, 'Date');
                        appendHiddenContactField(participantSection, 'Email', email, 'email');
                        appendHiddenContactField(participantSection, 'HKN_Gender__c', gender);
                        appendHiddenContactField(participantSection, 'HKN_NIF__c', documentNumber);
                        appendHiddenContactField(participantSection, 'HKN_PrefijoTelefono__c', phonePrefix);
                        appendHiddenContactField(participantSection, 'Phone', phone);
                        participantsContainer.appendChild(participantSection);
                    }
                }

                setSubmitState(false);
                closeFamilyModal();
            };

            if (addButton) {
                addButton.addEventListener('click', () => {
                    setMode('create');
                });
            }

            if (cancelEditButton) {
                cancelEditButton.addEventListener('click', () => {
                    form.reset();
                    if (memberIdInput) {
                        memberIdInput.value = '';
                    }
                    if (deleteEditButton) {
                        deleteEditButton.hidden = true;
                        deleteEditButton.dataset.memberId = '';
                    }
                    updateWebAccess();
                    toggleFormPanel(false);
                    hideFamilyError(manager);
                });
            }

            if (deleteEditButton) {
                deleteEditButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    deleteFamilyMember(deleteEditButton.dataset.memberId || memberIdInput?.value || '');
                });
            }

            if (birthdateInput) {
                ['change', 'input', 'blur'].forEach((eventName) => {
                    birthdateInput.addEventListener(eventName, updateWebAccess);
                });
            }

            if (webAccessToggle) {
                webAccessToggle.addEventListener('change', updateWebAccess);
            }

            form.addEventListener('invalid', (event) => {
                const invalidField = event.target;
                if (!(invalidField instanceof HTMLElement)) {
                    return;
                }
                toggleFormPanel(true);
                focusFamilyPanelNode(invalidField);
            }, true);

            familyCards.forEach((card) => {
                card.querySelector('[data-family-action="toggle-select"]')?.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    toggleFamilyCardSelection(card);
                });

                if (String(card.dataset.selectable || '') === '1') {
                    card.addEventListener('click', (event) => {
                        if (event.target instanceof Element && event.target.closest('[data-family-action]')) {
                            return;
                        }
                        toggleFamilyCardSelection(card);
                    });
                }

                card.querySelector('[data-family-action="edit"]')?.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    setMode('edit', card);
                });

                card.querySelector('[data-family-action="delete"]')?.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    deleteFamilyMember(card.dataset.memberId || '');
                });
            });

            if (familySelect) {
                const previousSyncHandler = familySelect.__hkFamilyModalSelectionSync;
                if (typeof previousSyncHandler === 'function') {
                    familySelect.removeEventListener('change', previousSyncHandler);
                }
                familySelect.__hkFamilyModalSelectionSync = syncModalSelectionState;
                familySelect.addEventListener('change', syncModalSelectionState);
            }

            form.addEventListener('submit', (event) => {
                event.preventDefault();
                hideFamilyError(manager);
                updateWebAccess();

                if (!validateFamilyRoleInput()) {
                    toggleFormPanel(true);
                    focusFamilyPanelNode(familyRoleInput);
                    setSubmitState(false);
                    if (typeof form.reportValidity === 'function') {
                        form.reportValidity();
                    }
                    return;
                }

                if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
                    setSubmitState(false);
                    return;
                }

                const formData = new FormData(form);
                const editingMemberId = String(memberIdInput?.value || '').trim();
                const isEditing = editingMemberId !== '';
                formData.set('HKN_Gender__c', normalizeContactGenderValue(formData.get('HKN_Gender__c') || ''));
                formData.set('action', isEditing ? 'sf_update_family_member' : 'sf_register_family_member');
                if (isEditing) {
                    formData.set('memberId', editingMemberId);
                }
                if (!localRegistrationMode) {
                    formData.delete('hk_family_role');
                }

                const submittedFirstName = String(formData.get('FirstName') || '').trim();
                const submittedLastName = String(formData.get('LastName') || '').trim();
                if (hasExistingFamilyFullName(submittedFirstName, submittedLastName, editingMemberId)) {
                    showFamilyError(manager, getDuplicateFamilyNameMessage(submittedFirstName, submittedLastName));
                    focusFamilyPanelNode(form.querySelector('#FirstName'));
                    setSubmitState(false);
                    return;
                }

                // Menor: la "cuenta propia en la web" se fuerza a NO aunque el
                // toggle estuviera activado (oculto en el modal por CSS, pero
                // por si llegara a recibirse). Solo los mayores de edad pueden
                // tener cuenta web propia con su email + invitación.
                const submitBirthdate = String(formData.get('Birthdate') || '').trim();
                const submitAge = getMemberAge(submitBirthdate, localProgramStartDate);
                const submitIsMinor = typeof submitAge === 'number' && submitAge < 18;
                const submitRole = normalizeManagerFamilyRole(formData.get('hk_family_role') || '');
                if (isExternalMinorRole(submitRole)) {
                    if (!localRegistrationMode || !localAllowsMinors || !localExternalMinorAllowed) {
                        showFamilyError(manager, 'Ese rol familiar no está permitido para esta actividad.');
                        setSubmitState(false);
                        return;
                    }
                    if (!submitIsMinor) {
                        showFamilyError(manager, externalMinorAgeErrorText);
                        setSubmitState(false);
                        return;
                    }
                    formData.set('new_user', 'no');
                    addLocalRegistrationParticipant(formData);
                    return;
                }
                if (submitIsMinor) {
                    formData.set('new_user', 'no');
                }

                setSubmitState(true);

                // Siempre POST a SF (decisión 18-may 2026, opción B):
                // "añadir familiar" implica añadir a la familia en Salesforce,
                // no solo a la inscripción in-memory. La parte "cuenta web"
                // solo decide si se envía email de invitación, no si se
                // persiste el lazo familiar. El backend valida + crea o
                // detecta duplicado + ofrece merge unipersonal / escala a
                // web@hakuna.org cuando hace falta.

                fetch(formActionUrl, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData,
                })
                    .then(parseFamilyJson)
                    .then((result) => {
                        if (!result?.success) {
                            if (!isEditing && result?.data?.flag === 'duplicate') {
                                showFamilyConfirm(manager, result?.data?.message || '', yesText, noText, () => {
                                    handleChangeFamilyMember(result?.data?.AccountId || '', result?.data?.memberId || '', formData);
                                }, () => {
                                    setSubmitState(false);
                                });
                                return null;
                            }

                            if (!isEditing && result?.data?.flag === 'family_surname_warning') {
                                const isSpanish = (document.documentElement?.lang || '').toLowerCase().startsWith('es');
                                // KAN-262: con pago inmediato no hay revisión diferida a
                                // la que mandar el alta (Salesforce manda
                                // familyMemberRequestAllowed=false). Se bloquea y se
                                // remite al email de dudas de la actividad.
                                const registerForm = document.getElementById('register-activity-form');
                                if (
                                    String(registerForm?.dataset?.familyRequestAllowed || '') === '0'
                                    || String(registerForm?.dataset?.immediatePayment || '') === '1'
                                ) {
                                    const supportEmail = String(registerForm?.dataset?.supportEmail || '').trim();
                                    const blockText = isSpanish
                                        ? `Este familiar no cumple los requisitos de validación de familia, así que no puede inscribirse por aquí.${supportEmail ? ` Si es de tu familia, escribe a ${supportEmail} y lo revisamos.` : ''}`
                                        : `This family member does not meet the family validation requirements, so they cannot be registered here.${supportEmail ? ` If they are part of your family, write to ${supportEmail} and we will review it.` : ''}`;
                                    form.querySelector('input[name="family_surname_review_request"]')?.remove();
                                    setSubmitState(false);
                                    showFamilyError(manager, blockText);
                                    document.dispatchEvent(new CustomEvent('hk:registration-family-blocked', { detail: { via: 'alta_familiar' } }));
                                    return null;
                                }
                                showFamilyConfirm(
                                    manager,
                                    result?.data?.message || '',
                                    isSpanish ? 'Solicitar añadir familiar' : 'Request family member review',
                                    isSpanish ? 'Revisar apellido' : 'Check surname',
                                    () => {
                                        let requestInput = form.querySelector('input[name="family_surname_review_request"]');
                                        if (!requestInput) {
                                            requestInput = document.createElement('input');
                                            requestInput.type = 'hidden';
                                            requestInput.name = 'family_surname_review_request';
                                            form.appendChild(requestInput);
                                        }
                                        requestInput.value = '1';
                                        setSubmitState(false);
                                        if (typeof form.requestSubmit === 'function') {
                                            form.requestSubmit();
                                        } else {
                                            form.dispatchEvent(new Event('submit', { cancelable: true }));
                                        }
                                    },
                                    () => {
                                        form.querySelector('input[name="family_surname_review_request"]')?.remove();
                                        setSubmitState(false);
                                    }
                                );
                                return null;
                            }

                            // Nonce/session caducados: ofrecer "Recargar página" como acción
                            // primaria en lugar del badge rojo seco. La pestaña ha estado
                            // abierta demasiado tiempo y el form lleva un nonce muerto;
                            // un reload regenera HTML + nonce y permite reintentar.
                            if (result?.data?.flag === 'nonce_expired' || result?.data?.flag === 'session_expired') {
                                showFamilyConfirm(
                                    manager,
                                    result?.data?.message || saveErrorText,
                                    'Recargar página',
                                    'Cancelar',
                                    () => { window.location.reload(); },
                                    () => { setSubmitState(false); }
                                );
                                return null;
                            }

                            throw new Error(result?.data?.message || saveErrorText);
                        }

                        if (!isEditing && result?.data?.flag === 'pending_family_review') {
                            const isSpanish = (document.documentElement?.lang || '').toLowerCase().startsWith('es');
                            form.querySelector('input[name="family_surname_review_request"]')?.remove();
                            setSubmitState(false);
                            if (window.dataLayer && Array.isArray(window.dataLayer)) {
                                window.dataLayer.push({
                                    event: 'family_review_requested',
                                    comp_core: { via: 'activity_register' },
                                });
                            }
                            showFamilyPendingNotice(
                                manager,
                                result?.data?.message || '',
                                isSpanish ? 'Entendido' : 'Got it',
                                closeFamilyModal
                            );
                            return null;
                        }

                        // Familiar nuevo creado o editado correctamente.
                        // Encolamos su memberId para que tras el reload quede
                        // pre-seleccionado en la inscripción (igual que en
                        // el flujo de merge).
                        const newMemberId = String(result?.data?.member?.Id || '').trim();
                        if (newMemberId !== '') {
                            queueFamilyPreselect(newMemberId);
                        }
                        form.querySelector('input[name="family_surname_review_request"]')?.remove();
                        reloadRegistration();
                    })
                    .catch((error) => {
                        form.querySelector('input[name="family_surname_review_request"]')?.remove();
                        showFamilyError(manager, error?.message || saveErrorText);
                        setSubmitState(false);
                    });
            });

            if (initialMode === 'create') {
                setMode('create');
                syncModalSelectionState();
                return;
            }

            toggleFormPanel(false);
            updateWebAccess();
            syncModalSelectionState();
        };
        const getOrCreateFamilyModal = () => {
            let modal = document.getElementById(familyModalId);
            if (modal) {
                return modal;
            }

            modal = document.createElement('div');
            modal.id = familyModalId;
            modal.innerHTML = `
                <div class="hk-family-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="hk-family-modal-title">
                    <div class="hk-family-modal__head">
                        <p class="hk-family-modal__title" id="hk-family-modal-title"></p>
                        <p class="hk-family-modal__subtitle"></p>
                        <button type="button" class="hk-family-modal__close" aria-label="Close">${closeIconSvg}</button>
                    </div>
                    <div class="hk-family-modal__body"></div>
                    <div class="hk-family-modal__footer" hidden>
                        <p class="hk-family-modal__summary" role="status"></p>
                        <button type="button" class="hk-family-modal__continue" disabled>
                            <span class="hk-family-modal__continue-label"></span>
                            <svg class="hk-family-modal__continue-ic" width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
                        </button>
                    </div>
                </div>
            `;
            document.body.appendChild(modal);

            const closeButton = modal.querySelector('.hk-family-modal__close');
            if (closeButton) {
                closeButton.addEventListener('click', closeFamilyModal);
            }
            // KAN-262: el pie solo se enseña con el selector de tipo; cerrar
            // con alguien elegido es continuar con la inscripción familiar.
            const continueButton = modal.querySelector('.hk-family-modal__continue');
            if (continueButton) {
                continueButton.addEventListener('click', closeFamilyModal);
            }
            modal.addEventListener('click', (event) => {
                if (event.target === modal) {
                    closeFamilyModal();
                }
            });
            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' && modal.classList.contains('is-visible')) {
                    closeFamilyModal();
                }
            });

            return modal;
        };
        const openFamilyModal = (button) => {
            if (!button) {
                return;
            }
            const templateId = String(button.dataset.familyModalTemplateId || '').trim();
            if (!templateId) {
                return;
            }

            const template = document.getElementById(templateId);
            if (!(template instanceof HTMLTemplateElement)) {
                return;
            }

            const modal = getOrCreateFamilyModal();
            const modalTitle = modal.querySelector('.hk-family-modal__title');
            const modalSubtitle = modal.querySelector('.hk-family-modal__subtitle');
            const modalCloseButton = modal.querySelector('.hk-family-modal__close');
            const modalBody = modal.querySelector('.hk-family-modal__body');
            if (!modalBody || !modalTitle || !modalSubtitle) {
                return;
            }

            const titleText = String(button.dataset.modalTitle || '').trim() || 'Add family members';
            const subtitleText = String(button.dataset.modalSubtitle || '').trim() || '';
            const closeText = String(button.dataset.modalClose || '').trim() || 'Close';
            modalTitle.textContent = titleText;
            modalSubtitle.textContent = subtitleText;
            if (modalCloseButton) {
                modalCloseButton.setAttribute('aria-label', closeText);
            }

            modalBody.replaceChildren(template.content.cloneNode(true));
            const manager = modalBody.querySelector('.hk-family-modal-manager');
            bindFamilyManager(modal, manager);
            modal.classList.add('is-visible');
            document.body.classList.add('hk-family-modal-open');
            document.dispatchEvent(new CustomEvent('hk:family-modal-opened'));
        };

        if (dismissButton) {
            dismissButton.addEventListener('click', () => {
                const familySection = familyHelperNotice.closest('.activity-register-section--family');
                if (familySection && !familySelect) {
                    familySection.style.display = 'none';
                    return;
                }

                familyHelperNotice.style.display = 'none';
            });
        }

        if (openButton) {
            openButton.addEventListener('click', () => {
                openFamilyModal(openButton);
            });
        }
    }

    window.addEventListener('storage', (event) => {
        if (event && event.key === familyStorageUpdateKey && event.newValue) {
            window.location.reload();
        }
    });

    // KAN-262: antes de las preguntas se elige entre inscripción familiar e
    // individual. «Familiar» abre el modal de siempre y, al cerrarlo con
    // alguien elegido, sigue a las preguntas. «Individual» va directa, con
    // el aviso de que luego no se puede pasar a familiar. El tipo se guarda
    // en sessionStorage porque dar de alta un familiar recarga la página.
    const registrationModeChooser = form.querySelector('[data-reg-mode-chooser="1"]');
    const registrationProgramId = String(form.querySelector('input[name="ProgramId"]')?.value || '').trim();
    const pushRegistrationEvent = (event, payload) => {
        window.dataLayer = window.dataLayer || [];
        const susVars = (typeof window.SUSVars === 'object' && window.SUSVars !== null) ? window.SUSVars : {};
        window.dataLayer.push({
            event,
            comp_core: Object.assign({
                activity_id: registrationProgramId,
                activity_name: susVars.activity_name || (susVars.activity && susVars.activity.Name) || '',
                activity_category: susVars.activity_category || susVars.activity_type || '',
                page_url: window.location.href,
            }, payload || {}),
        });
    };

    const provisionalHoldNotice = document.querySelector('.hk-provisional-hold-notice');
    if (provisionalHoldNotice) {
        pushRegistrationEvent('activity_capacity_blocked_view', {
            reserved_seats: Number.parseInt(provisionalHoldNotice.dataset.provisionalHold || '0', 10) || 0,
        });
    }

    if (registrationModeChooser) {
        // Señal para la red de seguridad de la vista: el selector arranca.
        form.setAttribute('data-reg-mode-ready', '1');
        const modeBar = form.querySelector('[data-reg-mode-bar]');
        const modeLabel = modeBar ? modeBar.querySelector('[data-reg-mode-label]') : null;
        const familyModeLabel = String(modeLabel?.textContent || '').trim();
        const individualNotice = form.querySelector('[data-reg-mode-notice]');
        const familySection = form.querySelector('.activity-register-section--family');
        const familyOpenButton = form.querySelector('.hk-family-helper-open');
        const modeStorageKey = `hk_registration_mode:${registrationProgramId}`;
        const isSpanishMode = (document.documentElement?.lang || '').toLowerCase().startsWith('es');
        const trackedBlockedMembers = new Set();
        let currentMode = null;

        const selectedFamilyCount = () => Array.from(familySelect?.selectedOptions || [])
            .filter((option) => String(option.value || '').trim() !== '')
            .length;
        const participantsCount = () => (currentMode === 'familiar' ? selectedFamilyCount() + 1 : 1);
        const trackMode = (event, payload) => {
            pushRegistrationEvent(event, Object.assign({
                registration_mode: currentMode || '',
                participants_count: participantsCount(),
            }, payload || {}));
        };
        const storeMode = (mode) => {
            try {
                if (mode) {
                    sessionStorage.setItem(modeStorageKey, mode);
                } else {
                    sessionStorage.removeItem(modeStorageKey);
                }
            } catch (error) {
                // sessionStorage puede fallar en modo privado; sin él solo se
                // pierde el tipo elegido al recargar.
            }
        };
        const readStoredMode = () => {
            try {
                return String(sessionStorage.getItem(modeStorageKey) || '');
            } catch (error) {
                return '';
            }
        };
        const updateModeLabel = () => {
            if (!modeLabel) {
                return;
            }
            const people = selectedFamilyCount() + 1;
            modeLabel.textContent = isSpanishMode
                ? `${familyModeLabel} · ${people} personas`
                : `${familyModeLabel} · ${people} people`;
        };
        const updateModalFooter = () => {
            const footer = document.querySelector(`#${familyModalId} .hk-family-modal__footer`);
            if (!footer) {
                return;
            }
            const count = selectedFamilyCount();
            footer.hidden = false;
            const summaryNode = footer.querySelector('.hk-family-modal__summary');
            if (summaryNode) {
                if (count === 0) {
                    summaryNode.textContent = isSpanishMode ? 'Elige al menos un familiar para continuar' : 'Choose at least one family member to continue';
                } else if (count === 1) {
                    summaryNode.textContent = isSpanishMode ? '1 familiar elegido' : '1 family member chosen';
                } else {
                    summaryNode.textContent = isSpanishMode ? `${count} familiares elegidos` : `${count} family members chosen`;
                }
            }
            const continueLabel = footer.querySelector('.hk-family-modal__continue-label');
            if (continueLabel) {
                continueLabel.textContent = isSpanishMode ? 'Continuar con la inscripción' : 'Continue with registration';
            }
            const continueButton = footer.querySelector('.hk-family-modal__continue');
            if (continueButton) {
                continueButton.disabled = count === 0;
            }
        };
        const applyMode = (mode) => {
            currentMode = mode || null;
            form.dataset.registrationMode = currentMode || '';
            if (currentMode) {
                form.removeAttribute('data-reg-mode-pending');
            } else {
                form.setAttribute('data-reg-mode-pending', '1');
            }
            registrationModeChooser.hidden = Boolean(currentMode);
            if (modeBar) {
                modeBar.hidden = currentMode !== 'familiar';
            }
            if (individualNotice) {
                individualNotice.hidden = currentMode !== 'individual';
            }
            if (familySection) {
                familySection.style.display = currentMode === 'individual' ? 'none' : '';
            }
            if (currentMode === 'individual' && familySelect) {
                let changed = false;
                Array.from(familySelect.options || []).forEach((option) => {
                    if (option.selected) {
                        option.selected = false;
                        changed = true;
                    }
                });
                if (changed) {
                    familySelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
            updateModeLabel();
            storeMode(currentMode);
        };
        // La cabecera del sitio es fija: hay que descontarla para que lo que
        // se enseña (el aviso de la individual, la barra de la familiar o el
        // selector) quede visible arriba y no debajo de ella.
        const fixedHeaderOffset = () => {
            const header = document.querySelector('header.site-header');
            if (!header) {
                return 0;
            }
            const position = window.getComputedStyle(header).position;
            if (position !== 'fixed' && position !== 'sticky') {
                return 0;
            }
            return Math.max(0, header.getBoundingClientRect().bottom);
        };
        const scrollToForm = () => {
            let target = registrationModeChooser;
            if (currentMode === 'individual') {
                target = individualNotice;
            } else if (currentMode === 'familiar') {
                target = modeBar || familySection;
            }
            const node = target && !target.hidden ? target : form;
            requestAnimationFrame(() => {
                const top = Math.max(0, node.getBoundingClientRect().top + window.scrollY - fixedHeaderOffset() - 16);
                try {
                    window.scrollTo({ top, behavior: 'smooth' });
                } catch (error) {
                    window.scrollTo(0, top);
                }
            });
        };
        const openFamilyFromMode = () => {
            if (!familyOpenButton) {
                applyMode('familiar');
                return;
            }
            // Si da de alta a un familiar la página se recarga: que vuelva en
            // modo familiar. Al cerrar el modal se corrige si no eligió a nadie.
            storeMode('familiar');
            familyOpenButton.click();
        };

        registrationModeChooser.querySelectorAll('[data-reg-mode]').forEach((button) => {
            button.addEventListener('click', () => {
                if (button.dataset.regMode === 'familiar') {
                    openFamilyFromMode();
                    return;
                }
                applyMode('individual');
                trackMode('activity_registration_mode_select');
                scrollToForm();
            });
        });

        individualNotice?.querySelector('[data-reg-mode-switch="familiar"]')?.addEventListener('click', openFamilyFromMode);

        modeBar?.querySelector('[data-reg-mode-change]')?.addEventListener('click', () => {
            trackMode('activity_registration_mode_change', { previous_mode: currentMode || '', registration_mode: '' });
            applyMode(null);
            scrollToForm();
        });

        document.addEventListener('hk:family-modal-opened', () => {
            updateModalFooter();
            document.querySelectorAll(`#${familyModalId} .hk-family-modal-member--blocked`).forEach((card) => {
                const memberId = String(card.dataset.memberId || '').trim();
                if (!memberId || trackedBlockedMembers.has(memberId)) {
                    return;
                }
                trackedBlockedMembers.add(memberId);
                trackMode('activity_family_member_blocked', {
                    block_reason: String(card.dataset.blockCode || '').trim() || 'composicion_familiar',
                    via: 'modal',
                });
            });
        });

        document.addEventListener('hk:registration-family-blocked', (event) => {
            trackMode('activity_family_member_blocked', {
                block_reason: 'composicion_familiar',
                via: String(event?.detail?.via || 'alta_familiar'),
            });
        });

        document.addEventListener('hk:family-modal-closed', () => {
            const count = selectedFamilyCount();
            const previousMode = currentMode;
            if (count > 0 && previousMode !== 'familiar') {
                applyMode('familiar');
                if (previousMode === 'individual') {
                    trackMode('activity_registration_mode_change', { previous_mode: 'individual' });
                } else {
                    trackMode('activity_registration_mode_select');
                }
                scrollToForm();
                return;
            }
            if (count === 0 && previousMode === 'familiar') {
                applyMode(null);
                scrollToForm();
                return;
            }
            // Sin cambio de tipo: deshace el «familiar» provisional del alta.
            storeMode(currentMode);
            updateModeLabel();
        });

        if (familySelect) {
            familySelect.addEventListener('change', () => {
                updateModeLabel();
                updateModalFooter();
            });
        }

        form.addEventListener('submit', () => {
            storeMode(null);
        });

        const storedMode = readStoredMode();
        if (storedMode === 'familiar' && selectedFamilyCount() > 0) {
            applyMode('familiar');
        } else if (storedMode === 'individual') {
            applyMode('individual');
        } else {
            applyMode(null);
        }
    }

    const isGuestRegistrationForm = String(form.dataset.guestRegistration || '') === '1';
    const participantsContainer = form.querySelector('#hk-registration-participants');
    const participantTemplate = form.querySelector('#hk-registration-participant-template');
    const isMultiParticipantFlow = Boolean(participantsContainer && participantTemplate && !isGuestRegistrationForm);
    let familyParticipantsCatalog = [];

    if (participantsContainer) {
        try {
            familyParticipantsCatalog = JSON.parse(participantsContainer.dataset.familyParticipants || '[]');
        } catch (error) {
            familyParticipantsCatalog = [];
        }
    }

    const escapeHtml = (value) => String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    const normalizeFamilyText = (value) => String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();

    const externalMinorCanonicalRole = 'Menor de fuera de la familia';
    const externalMinorDefaultNotice = 'Menor de fuera de la familia. Se revisará al asignar plaza.';
    const isExternalMinorFamilyRoleText = (value) => {
        const normalized = normalizeFamilyText(value);
        if (!normalized) {
            return false;
        }
        const compact = normalized.replace(/\s+/g, '');
        return [
            'menordefueradelafamilia',
            'menorfuerafamilia',
            'menorexterno',
            'minorexterno',
            'externalminor',
            'nonfamilyminor',
            'outsidefamilyminor',
        ].includes(compact)
            || (normalized.includes('menor') && normalized.includes('fuera') && normalized.includes('familia'));
    };

    const normalizeContactGenderValue = (value) => {
        const rawValue = String(value || '').trim();
        const normalized = normalizeFamilyText(rawValue);
        if (!normalized) {
            return '';
        }
        if (['0', 'masculino', 'masculina', 'male', 'man', 'hombre', 'varon', 'chico'].includes(normalized)) {
            return '0';
        }
        if (['1', 'femenino', 'femenina', 'female', 'woman', 'mujer', 'chica'].includes(normalized)) {
            return '1';
        }
        return '';
    };

    const normalizeQuestionScope = (value) => {
        const normalized = normalizeFamilyText(value).replace(/\s+/g, '');
        if (['unavezporfamilia', 'unavezfamilia', 'familia', 'familyonce', 'onceperfamily', 'family'].includes(normalized)) {
            return 'family_once';
        }
        if (['soloadultos', 'adultos', 'adultsonly', 'adults', 'mayores', 'solomayores'].includes(normalized)) {
            return 'adults_only';
        }
        if (['solohijos', 'hijos', 'menores', 'solomenores', 'childrenonly', 'children', 'kids', 'dependientes'].includes(normalized)) {
            return 'children_only';
        }
        return 'all';
    };

    const getParticipantAgeFromBirthdate = (rawValue) => {
        const normalized = String(rawValue || '').trim();
        if (!normalized) {
            return null;
        }

        const birthdate = new Date(`${normalized}T00:00:00`);
        if (Number.isNaN(birthdate.getTime())) {
            return null;
        }

        const today = new Date();
        let age = today.getFullYear() - birthdate.getFullYear();
        const monthDelta = today.getMonth() - birthdate.getMonth();
        if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < birthdate.getDate())) {
            age -= 1;
        }

        return age;
    };

    const truthyMeta = (value) => value === true || String(value || '') === '1' || String(value || '').toLowerCase() === 'true';

    const buildParticipantScopeContext = (section, participant = {}) => {
        const dataset = section?.dataset || {};
        return {
            isOwner: truthyMeta(participant.is_owner ?? participant.isOwner ?? dataset.isOwner),
            birthdate: String(participant.birthdate || participant.Birthdate || participant.BirthDate || dataset.birthdate || ''),
            candidateType: String(participant.candidate_type || participant.candidateType || dataset.candidateType || ''),
            candidateRole: String(participant.candidate_role || participant.candidateRole || dataset.candidateRole || ''),
            familyRole: String(participant.family_role || participant.familyRole || dataset.familyRole || ''),
            gender: normalizeContactGenderValue(participant.gender || participant.HKN_Gender__c || dataset.gender || ''),
            isChild: participant.is_child ?? participant.isChild ?? dataset.isChild,
            isAdult: participant.is_adult ?? participant.isAdult ?? dataset.isAdult,
        };
    };

    const normalizeParticipantFamilyRole = (rawRole) => {
        const normalized = normalizeFamilyText(rawRole);
        if (isExternalMinorFamilyRoleText(normalized)) {
            return externalMinorCanonicalRole;
        }
        if (/\b(hijo|hija|child|son|daughter|dependent|dependiente|menor|minor|nino|nina|bebe|baby)\b/.test(normalized)) {
            return 'Hijo';
        }
        if (/\b(conyuge|conjuge|spouse|marido|mujer|pareja)\b/.test(normalized)) {
            return 'Cónyuge';
        }
        if (/\b(acompanante|companion|guest|invitado|adult companion)\b/.test(normalized)) {
            return 'Acompañante';
        }
        return '';
    };

    const childRoleLabelFromGender = (gender) => {
        const normalized = normalizeFamilyText(gender);
        if (['1', 'femenino', 'female', 'mujer', 'woman', 'f'].includes(normalized)) {
            return 'Hija';
        }
        if (['0', 'masculino', 'male', 'hombre', 'man', 'm'].includes(normalized)) {
            return 'Hijo';
        }
        return 'Hijo/a';
    };

    const spouseRoleLabelFromGender = (gender) => {
        const normalized = normalizeFamilyText(gender);
        if (['1', 'femenino', 'female', 'mujer', 'woman', 'f'].includes(normalized)) {
            return 'Mujer';
        }
        if (['0', 'masculino', 'male', 'hombre', 'man', 'm'].includes(normalized)) {
            return 'Marido';
        }
        return 'Cónyuge';
    };

    const participantLooksChild = (context) => {
        if (truthyMeta(context.isChild)) {
            return true;
        }
        if (truthyMeta(context.isOwner)) {
            return false;
        }

        const age = getParticipantAgeFromBirthdate(context.birthdate);
        if (typeof age === 'number' && age < 18) {
            return true;
        }

        return /\b(hijo|hija|child|son|daughter|dependent|dependiente|menor|minor|nino|nina|bebe|baby)\b/.test(
            normalizeFamilyText(`${context.familyRole} ${context.candidateType} ${context.candidateRole}`)
        );
    };

    const participantLooksAdult = (context) => {
        if (truthyMeta(context.isOwner)) {
            return true;
        }
        if (participantLooksChild(context)) {
            return false;
        }
        if (truthyMeta(context.isAdult)) {
            return true;
        }

        const age = getParticipantAgeFromBirthdate(context.birthdate);
        if (typeof age === 'number') {
            return age >= 18;
        }

        return /\b(adulto|adult|mayor|conyuge|conjuge|spouse|marido|mujer|padre|madre|father|mother|parent|acompanante|companion|guest|invitado)\b/.test(
            normalizeFamilyText(`${context.familyRole} ${context.candidateType} ${context.candidateRole}`)
        );
    };

    const participantScopeLooksChild = (context) => {
        if (truthyMeta(context.isOwner)) {
            return false;
        }

        const age = getParticipantAgeFromBirthdate(context.birthdate);
        if (typeof age === 'number') {
            return age < 18;
        }

        return participantLooksChild(context);
    };

    const participantScopeLooksAdult = (context) => {
        if (truthyMeta(context.isOwner)) {
            return true;
        }

        const age = getParticipantAgeFromBirthdate(context.birthdate);
        if (typeof age === 'number') {
            return age >= 18;
        }

        return participantLooksAdult(context);
    };

    const resolveParticipantFamilyRole = (context) => {
        // El titular (responsable) no es un familiar — su rol canónico SF
        // es 'Responsable'. Esto solo se usa internamente para el scope de
        // preguntas; el form/payload de inscripción decide el HKN_Rol__c
        // por separado en build*Payload.
        if (truthyMeta(context.isOwner)) {
            return 'Responsable';
        }

        const explicitRole = normalizeParticipantFamilyRole(`${context.familyRole} ${context.candidateRole}`);
        if (explicitRole) {
            return explicitRole;
        }

        return participantLooksChild(context) ? 'Hijo' : 'Cónyuge';
    };

    const questionScopeAppliesToParticipant = (scope, context) => {
        const normalized = normalizeQuestionScope(scope);
        if (normalized === 'family_once') {
            return truthyMeta(context.isOwner);
        }
        if (normalized === 'adults_only') {
            return participantScopeLooksAdult(context);
        }
        if (normalized === 'children_only') {
            return participantScopeLooksChild(context);
        }
        return true;
    };

    const applyQuestionScopes = (section, participant = {}) => {
        if (!section) {
            return;
        }

        const rawContext = buildParticipantScopeContext(section, participant);
        const resolvedFamilyRole = resolveParticipantFamilyRole(rawContext);
        const context = {
            ...rawContext,
            familyRole: resolvedFamilyRole,
        };
        context.isChild = participantLooksChild(context);
        context.isAdult = participantLooksAdult(context);
        section.dataset.birthdate = context.birthdate;
        section.dataset.candidateType = context.candidateType;
        section.dataset.candidateRole = context.candidateRole;
        section.dataset.familyRole = context.familyRole;
        section.dataset.gender = context.gender;
        section.dataset.isChild = context.isChild ? '1' : '0';
        section.dataset.isAdult = context.isAdult ? '1' : '0';

        section.querySelectorAll('[data-family-scope]').forEach((block) => {
            const applies = questionScopeAppliesToParticipant(block.dataset.familyScope || 'all', context);
            if (!applies) {
                block.remove();
                return;
            }
            block.hidden = !applies;
            block.setAttribute('aria-hidden', applies ? 'false' : 'true');
            block.querySelectorAll('input, select, textarea').forEach((field) => {
                if (!field.dataset.scopeRequiredInitialized) {
                    field.dataset.scopeRequiredInitialized = '1';
                    field.dataset.scopeWasRequired = field.required ? '1' : '0';
                }
                field.disabled = !applies;
                field.required = applies && field.dataset.scopeWasRequired === '1';
            });
        });
    };

    const getParticipantSections = () => {
        if (!participantsContainer) {
            return [];
        }
        return Array.from(participantsContainer.querySelectorAll('.activity-register-participant'));
    };

    const parsePackCapacityNumber = (value) => {
        if (value === undefined || value === null || value === '') {
            return null;
        }
        const normalized = String(value).trim().replace(',', '.');
        if (!normalized) {
            return null;
        }
        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : null;
    };

    const formatPackCapacityNumber = (value) => {
        if (!Number.isFinite(value)) {
            return '';
        }
        if (Math.abs(value - Math.round(value)) < 0.00001) {
            return String(Math.round(value));
        }
        return String(value).replace('.', ',');
    };

    const getRegistrationParticipantCount = () => {
        const sections = getParticipantSections();
        return sections.length > 0 ? sections.length : 1;
    };

    const getPackCapacityHint = (select) => {
        if (!select) {
            return null;
        }
        const describedBy = String(select.getAttribute('aria-describedby') || '').trim();
        if (describedBy) {
            const hinted = document.getElementById(describedBy);
            if (hinted) {
                return hinted;
            }
        }
        const wrapper = select.closest('.activity-input-select, .activity-register-section--pack, .activity-register-form');
        return wrapper ? wrapper.querySelector('[data-pack-capacity-hint="1"]') : null;
    };

    const setPackCapacityHint = (hint, text, state) => {
        if (!hint) {
            return;
        }
        hint.classList.remove(
            'activity-pack-capacity-hint--available',
            'activity-pack-capacity-hint--warn',
            'activity-pack-capacity-hint--soldout',
        );
        if (!text) {
            hint.hidden = true;
            hint.textContent = '';
            return;
        }
        hint.textContent = text;
        hint.hidden = false;
        if (state) {
            hint.classList.add(`activity-pack-capacity-hint--${state}`);
        }
    };

    const updatePackCapacityHint = (select) => {
        if (!select) {
            return;
        }
        const hint = getPackCapacityHint(select);
        const option = select.selectedOptions && select.selectedOptions.length
            ? select.selectedOptions[0]
            : null;
        if (!option || option.dataset.capacityManaged !== '1') {
            const managedOptions = Array.from(select.options || [])
                .filter((candidate) => candidate.dataset.capacityManaged === '1');
            if (
                managedOptions.length > 0
                && managedOptions.every((candidate) => candidate.dataset.capacitySoldOut === '1')
            ) {
                setPackCapacityHint(
                    hint,
                    'Las modalidades con cupo propio están completas. Puedes elegir una e inscribirte; la plaza quedará pendiente de confirmar.',
                    'soldout',
                );
                return;
            }
            setPackCapacityHint(hint, '', '');
            return;
        }

        const packLabel = String(option.dataset.capacityPackLabel || option.textContent || '').trim();
        const capacityLabel = String(option.dataset.capacityLabel || '').trim();
        const available = parsePackCapacityNumber(option.dataset.capacityAvailable);
        const used = parsePackCapacityNumber(option.dataset.capacityUsed);
        const total = parsePackCapacityNumber(option.dataset.capacityTotal);
        const participantCount = getRegistrationParticipantCount();
        const participantLabel = participantCount === 1 ? '1 participante' : `${participantCount} participantes`;
        const isSoldOut = option.dataset.capacitySoldOut === '1' || (available !== null && available <= 0);
        const messageParts = [];
        let state = 'available';

        if (isSoldOut) {
            messageParts.push(`${packLabel} completo. Puedes apuntarte igualmente; la plaza quedará pendiente de confirmar.`);
            state = 'soldout';
        } else if (available !== null) {
            const seatsLabel = available === 1 ? 'plaza' : 'plazas';
            messageParts.push(`Quedan ${formatPackCapacityNumber(available)} ${seatsLabel} en ${packLabel}.`);
            if (participantCount > available) {
                messageParts.push('Si no se puede confirmar todo el grupo, la inscripción quedará pendiente de confirmar.');
                state = 'warn';
            }
        } else if (capacityLabel) {
            messageParts.push(capacityLabel);
        } else if (used !== null && total !== null) {
            messageParts.push(`${formatPackCapacityNumber(used)}/${formatPackCapacityNumber(total)} ocupadas en ${packLabel}.`);
        }

        if (messageParts.length === 0) {
            setPackCapacityHint(hint, '', '');
            return;
        }
        messageParts.push(`Vas a inscribir ${participantLabel}.`);
        setPackCapacityHint(hint, messageParts.join(' '), state);
    };

    const updateAllPackCapacityHints = () => {
        form.querySelectorAll('[data-pay-pack-select="1"]').forEach(updatePackCapacityHint);
    };

    const bindPackCapacityHints = () => {
        form.querySelectorAll('[data-pay-pack-select="1"]').forEach((select) => {
            if (select.dataset.hkPackCapacityBound !== '1') {
                select.dataset.hkPackCapacityBound = '1';
                select.addEventListener('change', () => updatePackCapacityHint(select));
            }
            updatePackCapacityHint(select);
        });
    };

    const getPackScopedSelect = (container) => {
        if (!container) {
            return null;
        }
        return container.querySelector('[data-pay-pack-select="1"]')
            || form.querySelector('.activity-register-section--pack [data-pay-pack-select="1"]')
            || form.querySelector('[data-pay-pack-select="1"]')
            || form.querySelector('select[name="HKN_TipoInscripcion__c"], input[name="HKN_TipoInscripcion__c"]');
    };

    const registrationPackRequiresSportQuestions = (packValue) => {
        const normalized = normalizeLookupValue(String(packValue || ''));
        if (!normalized) {
            return true;
        }
        if (normalized.includes('torneo') || normalized.includes('golf') || normalized.includes('padel')) {
            return true;
        }

        const compact = normalized.replace(/\s+/g, '');
        if (['solocena', 'cenasola', 'solocomida', 'comidasola'].includes(compact)) {
            return false;
        }

        return ['cena', 'comida', 'almuerzo'].some((mealToken) => normalized.includes(mealToken)) ? false : true;
    };

    const getSelectedRegistrationPackValue = () => {
        const packSelect = getPackScopedSelect(form);
        return packSelect ? String(packSelect.value || '') : '';
    };

    const updatePackScopedQuestions = () => {
        const sportQuestions = form.querySelectorAll('[data-pack-scoped-question="sport"], [data-pack-scoped-question="golf"]');
        if (!sportQuestions.length) {
            return;
        }

        const showSportQuestions = registrationPackRequiresSportQuestions(getSelectedRegistrationPackValue());
        sportQuestions.forEach((block) => {
            block.hidden = !showSportQuestions;
            block.style.display = showSportQuestions ? '' : 'none';
            block.setAttribute('aria-hidden', showSportQuestions ? 'false' : 'true');
            block.querySelectorAll('input, select, textarea').forEach((field) => {
                if (!field.dataset.packScopeRequiredInitialized) {
                    field.dataset.packScopeRequiredInitialized = '1';
                    field.dataset.packScopeWasRequired = field.required ? '1' : '0';
                }
                field.disabled = !showSportQuestions;
                field.required = showSportQuestions && field.dataset.packScopeWasRequired === '1';
                if (!showSportQuestions) {
                    if (field.type === 'checkbox' || field.type === 'radio') {
                        field.checked = false;
                    } else {
                        field.value = '';
                    }
                }
            });
        });
    };

    const bindPackScopedQuestions = () => {
        form.querySelectorAll('[data-pay-pack-select="1"], select[name="HKN_TipoInscripcion__c"], input[name="HKN_TipoInscripcion__c"]').forEach((field) => {
            if (field.dataset.hkPackScopedQuestionsBound === '1') {
                return;
            }
            field.dataset.hkPackScopedQuestionsBound = '1';
            field.addEventListener('change', updatePackScopedQuestions);
        });
        updatePackScopedQuestions();
    };

    const updatePackScopedExtras = (container) => {
        const scope = container || form;
        const extraBlocks = scope.querySelectorAll('.activity-input-checkbox[data-pay]');
        if (!extraBlocks.length) {
            return;
        }

        const packSelect = getPackScopedSelect(scope);
        let selectedPay = packSelect ? String(packSelect.value || '') : '';
        if (!selectedPay) {
            // Pack único sin selector: el valor viaja en el input de fallback.
            const fallbackPack = form.querySelector('.hk-fallback-pack-input');
            selectedPay = fallbackPack ? String(fallbackPack.value || '') : '';
        }

        // Sin pack elegido solo se muestran los extras no ligados a un pack
        // concreto; con pack elegido, los suyos y los globales.
        extraBlocks.forEach((block) => {
            const scopedPay = String(block.dataset.pay || '');
            const isActive = scopedPay === '' || (selectedPay !== '' && scopedPay === selectedPay);
            block.style.display = isActive ? '' : 'none';
            block.querySelectorAll('input[type="checkbox"]').forEach((input) => {
                input.disabled = !isActive;
                if (!isActive) {
                    input.checked = false;
                }
            });
        });

        // Si no queda ningún extra visible, fuera el subgrupo entero
        // (título "Extras opcionales" y separador incluidos).
        form.querySelectorAll('.activity-register-section__subgroup--extras').forEach((subgroup) => {
            const hasVisible = Array.from(subgroup.querySelectorAll('.activity-input-checkbox[data-pay]'))
                .some((block) => block.style.display !== 'none');
            subgroup.style.display = hasVisible ? '' : 'none';
        });
    };

    const bindPackScopedExtras = (container) => {
        const scope = container || form;
        if (!scope || scope.dataset?.extrasBound === '1') {
            updatePackScopedExtras(scope);
            return;
        }

        const packSelect = getPackScopedSelect(scope);
        if (packSelect && packSelect.dataset.hkExtraScopeBound !== '1') {
            packSelect.dataset.hkExtraScopeBound = '1';
            packSelect.addEventListener('change', () => {
                updatePackScopedExtras(form);
            });
        }

        if (scope.dataset) {
            scope.dataset.extrasBound = '1';
        }
        updatePackScopedExtras(scope);
    };

    const isSuccessfulField = (field) => {
        if (!field || field.disabled || !field.name) {
            return false;
        }

        if (field.type === 'radio' || field.type === 'checkbox') {
            return Boolean(field.checked);
        }

        return true;
    };

    const captureSectionValues = (section) => {
        const values = {};
        if (!section) {
            return values;
        }

        section.querySelectorAll('input[name], select[name], textarea[name]').forEach((field) => {
            if (field.disabled || !field.name) {
                return;
            }

            const key = `${field.dataset.form || 'default'}::${field.name}`;
            if (field.type === 'radio') {
                if (field.checked) {
                    values[key] = field.value;
                }
                return;
            }

            if (field.type === 'checkbox') {
                if (field.name === 'HKN_Extras_contratados__c') {
                    if (!Array.isArray(values[key])) {
                        values[key] = [];
                    }
                    if (field.checked) {
                        values[key].push(field.value);
                    }
                    return;
                }
                values[key] = field.checked;
                return;
            }

            values[key] = field.value;
        });

        return values;
    };

    // Con skipQuestions no toca las preguntas del cuestionario (los bloques
    // con data-family-scope): las respuestas de una persona no se copian a otra.
    const applySectionValues = (section, values, skipQuestions = false) => {
        if (!section || !values || typeof values !== 'object') {
            return;
        }

        section.querySelectorAll('input[name], select[name], textarea[name]').forEach((field) => {
            if (!field.name) {
                return;
            }
            if (skipQuestions && field.closest('[data-family-scope]')) {
                return;
            }

            const key = `${field.dataset.form || 'default'}::${field.name}`;
            if (!(key in values)) {
                return;
            }

            if (field.type === 'radio') {
                field.checked = String(values[key]) === String(field.value);
                return;
            }

            if (field.type === 'checkbox') {
                if (field.name === 'HKN_Extras_contratados__c') {
                    const checkedValues = Array.isArray(values[key]) ? values[key].map(String) : [];
                    field.checked = checkedValues.includes(String(field.value));
                    return;
                }
                field.checked = Boolean(values[key]);
                return;
            }

            field.value = values[key];
        });
    };

    // Lo que la persona ya contestó en inscripciones anteriores (Salesforce lo
    // manda como 'Objeto.Campo' => valor). Con onlyEmpty no pisa lo que ya
    // haya escrito; sin él, pisa lo copiado del responsable. Las cláusulas
    // legales no vienen: van por su propio camino.
    const applyPreviousAnswers = (section, answers, onlyEmpty) => {
        if (!section || !answers || typeof answers !== 'object') {
            return 0;
        }
        let filled = 0;
        Object.keys(answers).forEach((answerKey) => {
            const dot = answerKey.indexOf('.');
            if (dot < 1) {
                return;
            }
            const sfObject = answerKey.slice(0, dot);
            const sfField = answerKey.slice(dot + 1);
            const value = answers[answerKey];
            const fields = Array.from(section.querySelectorAll('input, select, textarea')).filter((field) => (
                !field.disabled
                && field.dataset.imageRightsConsent !== '1'
                && String(field.dataset.form || '') === sfObject
                && String(field.dataset.fieldName || field.name || '') === sfField
            ));
            if (!fields.length) {
                return;
            }
            const first = fields[0];
            if (first.type === 'radio') {
                if (onlyEmpty && fields.some((radio) => radio.checked)) {
                    return;
                }
                const wanted = value === true ? 'true' : String(value).toLowerCase();
                const match = fields.find((radio) => String(radio.value).toLowerCase() === wanted);
                if (match) {
                    match.checked = true;
                    filled++;
                }
                return;
            }
            if (first.type === 'checkbox') {
                if (value === true && !(onlyEmpty && first.checked)) {
                    first.checked = true;
                    filled++;
                }
                return;
            }
            if (onlyEmpty && String(first.value || '') !== '') {
                return;
            }
            const text = String(value);
            if (first.tagName === 'SELECT' && !Array.from(first.options).some((option) => option.value === text)) {
                return;
            }
            first.value = text;
            filled++;
        });
        return filled;
    };

    // La tarjeta del responsable sale del servidor: se rellena al cargar, sin
    // pisar lo que el navegador haya restaurado.
    if (isMultiParticipantFlow) {
        let ownerPreviousAnswers = {};
        try {
            ownerPreviousAnswers = JSON.parse(participantsContainer.dataset.ownerPreviousAnswers || '{}');
        } catch (error) {
            ownerPreviousAnswers = {};
        }
        const prefilledOwnerFields = applyPreviousAnswers(
            participantsContainer.querySelector('.activity-register-participant[data-is-owner="1"]'),
            ownerPreviousAnswers,
            true
        );
        if (prefilledOwnerFields > 0) {
            pushRegistrationEvent('activity_registration_prefilled', { step_number: prefilledOwnerFields, via: 'responsable' });
        }
    }

    const updateParticipantExtras = (participantSection) => {
        updatePackScopedExtras(participantSection);
    };

    const bindParticipantExtras = (participantSection) => {
        if (!participantSection || participantSection.dataset.extrasBound === '1') {
            updateParticipantExtras(participantSection);
            return;
        }

        const packSelect = participantSection.querySelector('[data-pay-pack-select="1"]');
        if (packSelect) {
            packSelect.addEventListener('change', () => {
                updateParticipantExtras(participantSection);
            });
        }

        participantSection.dataset.extrasBound = '1';
        updateParticipantExtras(participantSection);
    };

    const createParticipantSection = (participant, ownerDefaults, existingValues) => {
        if (!participantTemplate || !participant) {
            return null;
        }

        const participantKey = String(participant.participant_key || participant.contact_id || '').trim();
        const participantContactId = String(participant.contact_id || '').trim();
        if (!participantKey) {
            return null;
        }
        const templateHtml = String(participantTemplate.innerHTML || '')
            .replace(/__PARTICIPANT_KEY__/g, escapeHtml(participantKey))
            .replace(/__PARTICIPANT_LABEL__/g, escapeHtml(String(participant.label || participant.email || participantKey)))
            .replace(/__PARTICIPANT_CONTACT_ID__/g, escapeHtml(participantContactId))
            .replace(/__PARTICIPANT_EMAIL__/g, escapeHtml(String(participant.email || '')));

        if (!templateHtml.trim()) {
            return null;
        }

        const wrapper = document.createElement('div');
        wrapper.innerHTML = templateHtml.trim();
        const section = wrapper.firstElementChild;
        if (!section) {
            return null;
        }

        section.dataset.birthdate = String(participant.birthdate || participant.Birthdate || participant.BirthDate || '');
        section.dataset.candidateType = String(participant.candidate_type || participant.candidateType || '');
        section.dataset.candidateRole = String(participant.candidate_role || participant.candidateRole || '');
        section.dataset.familyRole = String(participant.family_role || participant.familyRole || '');
        section.dataset.gender = normalizeContactGenderValue(participant.gender || participant.HKN_Gender__c || '');
        if (participant.is_child !== undefined || participant.isChild !== undefined) {
            section.dataset.isChild = truthyMeta(participant.is_child ?? participant.isChild) ? '1' : '0';
        }
        if (participant.is_adult !== undefined || participant.isAdult !== undefined) {
            section.dataset.isAdult = truthyMeta(participant.is_adult ?? participant.isAdult) ? '1' : '0';
        }
        applyQuestionScopes(section, participant);

        // Variante visual del header según rol (owner/adult/child) y chip
        // de rol. La template del PHP los rendered con clase --adult genérica
        // sin chip (porque is_template=true), así que actualizamos aquí.
        const header = section.querySelector('.activity-register-participant__header');
        const roleContext = buildParticipantScopeContext(section, participant);
        const resolvedFamilyRole = resolveParticipantFamilyRole(roleContext);
        const isExternalMinor = isExternalMinorFamilyRoleText(resolvedFamilyRole || roleContext.familyRole || roleContext.candidateRole);
        section.dataset.familyRole = resolvedFamilyRole;
        section.dataset.isChild = participantLooksChild(roleContext) ? '1' : '0';
        section.dataset.isAdult = participantLooksAdult(roleContext) ? '1' : '0';
        section.dataset.externalMinor = isExternalMinor ? '1' : '0';
        if (header) {
            header.classList.remove(
                'activity-register-participant__header--owner',
                'activity-register-participant__header--adult',
                'activity-register-participant__header--child',
                'activity-register-participant__header--external-minor'
            );
            const isChild = section.dataset.isChild === '1';
            header.classList.add(isExternalMinor
                ? 'activity-register-participant__header--external-minor'
                : (isChild ? 'activity-register-participant__header--child' : 'activity-register-participant__header--adult'));
        }
        const chip = section.querySelector('.activity-register-participant__role-chip');
        if (chip) {
            let chipText = '';
            if (isExternalMinor) {
                chipText = externalMinorCanonicalRole;
            } else if (resolvedFamilyRole === 'Cónyuge') {
                chipText = spouseRoleLabelFromGender(roleContext.gender);
            } else if (resolvedFamilyRole === 'Acompañante') {
                chipText = 'Acompañante';
            } else if (resolvedFamilyRole === 'Hijo' || section.dataset.isChild === '1') {
                chipText = childRoleLabelFromGender(roleContext.gender);
            }
            chip.textContent = chipText;
            chip.hidden = chipText === '';
        }
        const existingExternalNotice = section.querySelector('.activity-register-participant__external-minor-note');
        if (isExternalMinor) {
            if (!existingExternalNotice) {
                const note = document.createElement('p');
                note.className = 'activity-register-participant__external-minor-note';
                const noticeText = document
                    .querySelector('.hk-family-modal-manager[data-external-minor-notice]')
                    ?.dataset.externalMinorNotice || externalMinorDefaultNotice;
                note.textContent = noticeText;
                if (header && header.parentNode) {
                    header.parentNode.insertBefore(note, header.nextSibling);
                } else {
                    section.insertBefore(note, section.firstChild);
                }
            }
        } else if (existingExternalNotice) {
            existingExternalNotice.remove();
        }

        // Del responsable se copia lo común (pack, extras), no sus respuestas:
        // cada familiar contesta lo suyo, y ahora cada respuesta se guarda en
        // su ficha y su inscripción.
        applySectionValues(section, ownerDefaults, true);
        applyPreviousAnswers(section, participant.previous_answers, false);
        applySectionValues(section, existingValues);
        applyQuestionScopes(section, participant);
        bindParticipantExtras(section);
        updatePackScopedQuestions();

        return section;
    };

    const syncFamilyParticipantSections = () => {
        if (!isMultiParticipantFlow || !familySelect || !participantsContainer) {
            return;
        }

        const ownerSection = participantsContainer.querySelector('.activity-register-participant[data-is-owner="1"]');
        const ownerDefaults = captureSectionValues(ownerSection);
        const currentSections = new Map();
        getParticipantSections().forEach((section) => {
            if (section.dataset.isOwner === '1') {
                return;
            }
            if (section.dataset.localParticipant === '1') {
                return;
            }
            const contactId = String(section.dataset.contactId || '').trim();
            if (!contactId) {
                return;
            }
            currentSections.set(contactId, captureSectionValues(section));
            section.remove();
        });

        const selectedIds = Array.from(familySelect.selectedOptions || [])
            .map((option) => String(option.value || '').trim())
            .filter((value) => value !== '');

        // Orden de las cards: el Responsable ya está en DOM (server-side).
        // Para el resto, primero Cónyuge y luego Hijos (por orden de
        // selección). Antes el orden era el del array de seleccionados,
        // por lo que un hijo aparecía antes que el cónyuge si se marcaba
        // primero en el modal.
        const rankParticipantForOrder = (participant) => {
            const context = buildParticipantScopeContext(null, participant || {});
            const role = resolveParticipantFamilyRole(context);
            if (role === 'Cónyuge') {
                return 1;
            }
            if (role === 'Acompañante') {
                return 2;
            }
            if (role === 'Hijo') {
                return 3;
            }
            return 4;
        };

        const orderedParticipants = selectedIds
            .map((contactId) => familyParticipantsCatalog.find((item) => String(item.contact_id || '').trim() === contactId))
            .filter((p) => p)
            .map((p, index) => ({ participant: p, originalIndex: index }))
            .sort((a, b) => {
                const ra = rankParticipantForOrder(a.participant);
                const rb = rankParticipantForOrder(b.participant);
                if (ra !== rb) return ra - rb;
                return a.originalIndex - b.originalIndex;
            });

        orderedParticipants.forEach(({ participant }) => {
            const contactId = String(participant.contact_id || '').trim();
            const participantSection = createParticipantSection(participant, ownerDefaults, currentSections.get(contactId));
            if (participantSection) {
                participantsContainer.appendChild(participantSection);
            }
        });

        // Marca el contenedor como solo/multi-participante. CSS lo usa
        // para ocultar el chip "RESPONSABLE" en solo (no aporta info) y
        // mostrarlo en multi (donde es útil para distinguir roles).
        const totalParticipants = participantsContainer.querySelectorAll('.activity-register-participant').length;
        participantsContainer.classList.toggle('is-solo-participant', totalParticipants <= 1);
        participantsContainer.classList.toggle('is-multi-participant', totalParticipants > 1);
        updateAllPackCapacityHints();
        updatePackScopedQuestions();
    };

    const normalizePayloadGroupKey = (rawFormKey) => {
        const normalized = String(rawFormKey || 'default').toLowerCase();
        if (normalized === 'programenrollment') {
            return 'enrollment';
        }
        if (normalized === 'contact') {
            return 'contact';
        }
        if (normalized === 'processes') {
            return 'processes';
        }
        return normalized;
    };

    const appendFieldValue = (target, field) => {
        const formKey = normalizePayloadGroupKey(field.dataset.form || 'default');
        const targetGroup = target[formKey] && typeof target[formKey] === 'object'
            ? target[formKey]
            : (target[formKey] = {});
        const fieldName = String(field.dataset.fieldName || field.name || '').trim();
        if (!fieldName) {
            return;
        }

        const fieldType = String(field.dataset.type || '');
        const incomingValue = field.type === 'checkbox' ? field.value : field.value;

        if (Object.prototype.hasOwnProperty.call(targetGroup, fieldName)) {
            if (Array.isArray(targetGroup[fieldName].value)) {
                targetGroup[fieldName].value.push(incomingValue);
            } else {
                targetGroup[fieldName].value = [targetGroup[fieldName].value, incomingValue];
            }
            return;
        }

        targetGroup[fieldName] = {
            value: incomingValue,
            form: field.dataset.form || 'default',
            type: fieldType || null,
        };
    };

    const buildLegacyPayload = (formData) => {
        const enrichedData = {};
        const skip = new Set(['action', '_wpnonce', '_wp_http_referer']);
        for (const [name, value] of formData.entries()) {
            if (skip.has(name)) continue;
            const inputs = form.querySelectorAll(`[name="${name}"]`);
            const field  = inputs.length > 1 && inputs[0].type === 'radio'
                ? form.querySelector(`[name="${name}"]:checked`)
                : inputs[0];

            if (!field) {
                continue;
            }

            // Los checkboxes de consentimiento de imagen NUNCA deben caer en
            // `enrichedData.Contact[...]`. SF los recibe vía
            // `hk_participant_answers.self.Contact.HKN_AceptaDerechosImagen__c=true`
            // que se inyecta después del buildLegacyPayload. Si dejamos pasar
            // el name HTML (p.ej. `hk_image_rights_consent`), SF responde
            // 'No such column on Contact'.
            if (field.dataset && field.dataset.imageRightsConsent === '1') {
                continue;
            }

            const payloadKey = String(field.dataset.fieldName || name || '').trim();
            if (!payloadKey) {
                continue;
            }

            const formKey = field.dataset.form || 'default';
            if (!enrichedData[formKey]) {
                enrichedData[formKey] = {};
            }

            if (enrichedData[formKey][payloadKey]) {
                if (Array.isArray(enrichedData[formKey][payloadKey].value)) {
                    enrichedData[formKey][payloadKey].value.push(value);
                } else {
                    enrichedData[formKey][payloadKey].value = [
                        enrichedData[formKey][payloadKey].value,
                        value
                    ];
                }
            } else {
                enrichedData[formKey][payloadKey] = {
                    value: value,
                    form: formKey,
                    type: field.dataset.type || null
                };
            }
        }

        return enrichedData;
    };

    const flattenLegacyPayloadGroup = (group) => {
        if (!group || typeof group !== 'object' || Array.isArray(group)) {
            return {};
        }

        return Object.entries(group).reduce((flattened, [key, field]) => {
            if (!key) {
                return flattened;
            }
            if (field && typeof field === 'object' && !Array.isArray(field) && Object.prototype.hasOwnProperty.call(field, 'value')) {
                flattened[key] = field.value;
                return flattened;
            }
            flattened[key] = field;
            return flattened;
        }, {});
    };

    const compactLegacyPayloadGroupValues = (group) => {
        if (!group || typeof group !== 'object' || Array.isArray(group)) {
            return;
        }

        Object.values(group).forEach((field) => {
            if (!field || typeof field !== 'object' || !Array.isArray(field.value)) {
                return;
            }
            const filtered = field.value.filter((item) => String(item || '').trim() !== '');
            if (filtered.length <= 1) {
                field.value = filtered[0] || '';
            } else {
                field.value = filtered;
            }
        });
    };

    const buildMultiParticipantPayload = () => {
        const payload = {
            shared: {
                contact: {},
                enrollment: {},
                processes: {},
            },
            participants: [],
        };

        form.querySelectorAll('input[name], select[name], textarea[name]').forEach((field) => {
            if (!isSuccessfulField(field)) {
                return;
            }

            const participantSection = field.closest('.activity-register-participant');
            if (participantSection) {
                return;
            }

            if (['action', '_wpnonce', '_wp_http_referer'].includes(field.name)) {
                return;
            }

            if (field.name === 'family_members[]') {
                return;
            }

            appendFieldValue(payload.shared, field);
        });

        getParticipantSections().forEach((section) => {
            const participantPayload = {
                participant_key: String(section.dataset.participantKey || '').trim(),
                contact_id: String(section.dataset.contactId || '').trim(),
                email: String(section.dataset.email || '').trim(),
                label: String(section.dataset.label || '').trim(),
                birthdate: String(section.dataset.birthdate || '').trim(),
                candidate_type: String(section.dataset.candidateType || '').trim(),
                candidate_role: String(section.dataset.candidateRole || '').trim(),
                family_role: String(section.dataset.familyRole || '').trim(),
                familyRole: String(section.dataset.familyRole || '').trim(),
                gender: normalizeContactGenderValue(section.dataset.gender || ''),
                is_child: String(section.dataset.isChild || '') === '1',
                is_adult: String(section.dataset.isAdult || '') === '1',
                contact: {},
                enrollment: {},
            };

            section.querySelectorAll('input[name], select[name], textarea[name]').forEach((field) => {
                if (!isSuccessfulField(field)) {
                    return;
                }
                // Los checkboxes de consentimiento de imagen los recogemos en bloque
                // más abajo bajo `payload.hk_participant_answers`. No deben acabar
                // bajo `participantPayload.Contact` por el genérico `appendFieldValue`.
                if (field.dataset && field.dataset.imageRightsConsent === '1') {
                    return;
                }

                appendFieldValue(participantPayload, field);
            });

            payload.participants.push(participantPayload);
        });

        // Consentimiento de derechos de imagen — recolecta los checkboxes con
        // `data-image-rights-consent="1"` y construye:
        //   payload.hk_participant_answers[<participant_key>]["Contact.HKN_AceptaDerechosImagen__c"] = true
        // El backend (build_activity_registration_rest_answers) mapea participant_key
        // → contactId vía built_participants y lo emite como
        // `answers.participants[<contactId>]["Contact.HKN_AceptaDerechosImagen__c"]`.
        // Para participantes recién creados (sin contactId), el backend no puede
        // usar `answers.participants[contactId]`, pero inyecta este mismo valor en
        // `participants[].contact.HKN_AceptaDerechosImagen__c` antes de enviar a SF.
        const imageRightsChecks = form.querySelectorAll('input[type="checkbox"][data-image-rights-consent="1"]');
        const participantAnswers = {};
        imageRightsChecks.forEach((input) => {
            if (!input.checked) {
                return;
            }
            const section = input.closest('.activity-register-participant');
            const participantKey = (section && section.dataset && section.dataset.participantKey)
                ? String(section.dataset.participantKey).trim()
                : String((input.dataset && input.dataset.participantKey) || '').trim();
            if (!participantKey) {
                return;
            }
            const sfObject = String((input.dataset && input.dataset.sfObject) || 'Contact').trim() || 'Contact';
            const sfField = String((input.dataset && input.dataset.sfField) || 'HKN_AceptaDerechosImagen__c').trim() || 'HKN_AceptaDerechosImagen__c';
            const fieldKey = `${sfObject}.${sfField}`;
            if (!participantAnswers[participantKey]) {
                participantAnswers[participantKey] = {};
            }
            participantAnswers[participantKey][fieldKey] = true;
        });
        if (Object.keys(participantAnswers).length > 0) {
            payload.hk_participant_answers = participantAnswers;
        }

        return payload;
    };

    if (isMultiParticipantFlow) {
        bindPackScopedExtras(form.querySelector('.activity-register-section--pack') || form);
        getParticipantSections().forEach((section) => {
            applyQuestionScopes(section);
            bindParticipantExtras(section);
        });
        if (familySelect) {
            familySelect.addEventListener('change', syncFamilyParticipantSections);
            syncFamilyParticipantSections();
        }

        // Tipo de inscripción global → mirrors por participante.
        // El <select data-pay-pack-select="1"> vive ahora en una sección
        // propia (.activity-register-section--pack) fuera de los
        // participantes. Cada participante (incluido el responsable) tiene
        // un <input type=hidden data-pay-pack-mirror="1"> que debe replicar
        // el value del select global. Esto permite que en submit cada
        // ProgramEnrollment lleve el mismo HKN_TipoInscripcion__c sin
        // duplicar el selector.
        const findGlobalPackSelect = () => {
            return form.querySelector('.activity-register-section--pack [data-pay-pack-select="1"]')
                || form.querySelector('[data-pay-pack-select="1"]');
        };
        const propagateGlobalPackToMirrors = () => {
            const select = findGlobalPackSelect();
            if (!select || !participantsContainer) return;
            const value = String(select.value || '');
            participantsContainer.querySelectorAll('[data-pay-pack-mirror="1"]').forEach((mirror) => {
                if (mirror.value !== value) {
                    mirror.value = value;
                    mirror.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        };
        const bindGlobalPackPropagation = () => {
            const select = findGlobalPackSelect();
            if (!select || select.dataset.hkPackMirrorBound === '1') return;
            select.dataset.hkPackMirrorBound = '1';
            select.addEventListener('change', () => {
                propagateGlobalPackToMirrors();
                updatePackCapacityHint(select);
                updatePackScopedExtras(form);
                updatePackScopedQuestions();
            });
            propagateGlobalPackToMirrors();
            updatePackCapacityHint(select);
            updatePackScopedExtras(form);
            updatePackScopedQuestions();
        };
        bindPackCapacityHints();
        bindGlobalPackPropagation();
        bindPackScopedQuestions();
        // Re-propagamos tras cada sync (mirrors recién insertados).
        if (familySelect) {
            familySelect.addEventListener('change', () => requestAnimationFrame(() => {
                bindPackCapacityHints();
                bindGlobalPackPropagation();
                propagateGlobalPackToMirrors();
                updatePackScopedExtras(form);
                updateAllPackCapacityHints();
                bindPackScopedQuestions();
            }));
        }
    }
    bindPackCapacityHints();
    bindPackScopedExtras(form.querySelector('.activity-register-section--pack') || form);
    bindPackScopedQuestions();

    const setSubmitButtonText = (submitButton, text) => {
        if (!submitButton) return;
        if (submitButton.tagName.toLowerCase() === 'input') {
            submitButton.value = text;
        } else {
            submitButton.innerText = text;
        }
    };

    // Barra de carga bajo el botón mientras se envía la inscripción. El alta
    // tarda unos segundos y con solo «Procesando...» parecía que no hacía nada.
    // Es la misma barra que la del aviso de redirección.
    const showSubmitProgress = (submitButton) => {
        const host = submitButton ? submitButton.parentElement : null;
        if (!host) return;
        if (!document.getElementById(submitProgressStylesId)) {
            const style = document.createElement('style');
            style.id = submitProgressStylesId;
            style.textContent = `
                .hk-submit-progress-host {
                    flex-direction: column;
                    align-items: center;
                }
                .hk-submit-progress {
                    position: relative;
                    display: block;
                    flex: 0 0 auto;
                    width: 100%;
                    height: 6px;
                    margin: 12px auto 0;
                    overflow: hidden;
                    border-radius: 999px;
                    background: #d7e4ea;
                }
                .hk-submit-progress::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    width: 46%;
                    border-radius: inherit;
                    background: #00ccd9;
                    animation: hk-submit-progress 1.1s ease-in-out infinite;
                }
                @keyframes hk-submit-progress {
                    from { transform: translateX(-105%); }
                    to { transform: translateX(225%); }
                }
            `;
            document.head.appendChild(style);
        }
        let bar = host.querySelector('.hk-submit-progress');
        if (!bar) {
            bar = document.createElement('span');
            bar.className = 'hk-submit-progress';
            bar.setAttribute('aria-hidden', 'true');
            host.appendChild(bar);
        }
        host.classList.add('hk-submit-progress-host');
        bar.style.maxWidth = `${submitButton.offsetWidth}px`;
    };

    const hideSubmitProgress = (submitButton) => {
        const host = submitButton ? submitButton.parentElement : null;
        if (!host) return;
        const bar = host.querySelector('.hk-submit-progress');
        if (bar) {
            bar.remove();
        }
        host.classList.remove('hk-submit-progress-host');
    };

    const restoreSubmitButton = (submitButton) => {
        if (!submitButton) return;
        hideSubmitProgress(submitButton);
        submitButton.disabled = false;
        const originalText = submitButton.dataset.originalText || 'Sign up!';
        const originalBackground = submitButton.dataset.originalBackground || '';
        setSubmitButtonText(submitButton, originalText);
        submitButton.style.background = originalBackground;
    };

    const tryParseActivityResponse = (rawText) => {
        if (typeof rawText !== 'string') {
            return null;
        }

        const trimmed = rawText.trim();
        if (!trimmed) {
            return null;
        }

        try {
            return JSON.parse(trimmed);
        } catch (error) {
            // Keep trying with JSON embedded in warnings/notices.
        }

        const successStart = trimmed.indexOf('{"success"');
        if (successStart !== -1) {
            const candidate = trimmed.slice(successStart);
            try {
                return JSON.parse(candidate);
            } catch (error) {
                // keep falling back
            }
        }

        const lastBrace = trimmed.lastIndexOf('}');
        const firstBrace = trimmed.indexOf('{');
        if (firstBrace !== -1 && lastBrace > firstBrace) {
            const candidate = trimmed.slice(firstBrace, lastBrace + 1);
            try {
                return JSON.parse(candidate);
            } catch (error) {
                return null;
            }
        }

        return null;
    };

    const extractActivityErrorMessageFromRawResponse = (rawText) => {
        const raw = typeof rawText === 'string' ? rawText : '';
        const normalized = raw
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();

        if (
            normalized.includes('data value too large')
            || normalized.includes('string_too_long')
            || normalized.includes('max length=')
        ) {
            if (
                normalized.includes('hkn_queestudias__c')
                || normalized.includes('hkn_aquetededicas__c')
                || normalized.includes('what do you for a living')
                || normalized.includes('que estudias')
            ) {
                return 'Ese campo se ha emocionado un poco. Cuéntanos qué estudias o a qué te dedicas en una versión más corta y vuelve a intentarlo.';
            }

            if (
                normalized.includes('hkn_comentarios__c')
                || normalized.includes('comentarios')
            ) {
                return 'Tus comentarios son demasiado largos. Haz una versión más corta y vuelve a intentarlo.';
            }

            return 'Hay un campo con demasiado texto. Hazlo un poco más corto y vuelve a intentarlo.';
        }

        if (normalized.includes('you are already subscribed') || normalized.includes('already subscribed')) {
            return 'Ya estabas inscrita en esta actividad.';
        }

        if (normalized.includes('security check failed')) {
            return 'La página se quedó vieja. Recárgala y vuelve a intentarlo.';
        }

        if (normalized.includes('json decoding failed')) {
            return 'El formulario llegó torcido al servidor. Recarga la página y vuelve a intentarlo.';
        }

        return suscriptionsData?.text?.requesterror || 'Error inesperado. Inténtalo de nuevo.';
    };

    // ------------------------------------------------------------------
    // Modal de datos incompletos (`profileBlocks`).
    //
    // Salesforce solo devuelve los bloques de ficha que están incompletos, con
    // lo que ya sabe precumplimentado. Si no devuelve ninguno —el caso del 97%
    // de la gente con cuenta web— este módulo no pinta nada y la inscripción va
    // por el camino rápido de siempre.
    //
    // Los campos NO se hardcodean: se leen del JSON que emite el servidor a
    // partir del GET de contexto. La excepción son los campos condicionados,
    // que Salesforce solo devuelve cuando ya se cumple su condición y que hay
    // que pintar en caliente si se cumple dentro del propio modal.
    // ------------------------------------------------------------------
    const profileBlocks = (() => {
        const inert = {
            enabled: false,
            isResolvedFor: () => true,
            open: () => {},
            getPayload: () => ({}),
            pendingContactIds: () => [],
        };

        const root = document.getElementById('hk-profile-blocks');
        const dataNode = document.getElementById('hk-profile-blocks-data');
        if (!root || !dataNode) {
            return inert;
        }

        let model = null;
        try {
            model = JSON.parse(dataNode.textContent || '{}');
        } catch (error) {
            return inert;
        }
        if (!model || !Array.isArray(model.participants) || model.participants.length === 0) {
            return inert;
        }

        const settings = (suscriptionsData && suscriptionsData.profileBlocks) ? suscriptionsData.profileBlocks : {};
        const texts = settings.text || {};
        const t = (key, fallback) => {
            const value = texts[key];
            return (typeof value === 'string' && value !== '') ? value : fallback;
        };
        const format = (template, ...replacements) => {
            let output = String(template || '');
            replacements.forEach((replacement, position) => {
                output = output
                    .replace(new RegExp(`%${position + 1}\\$s`, 'g'), String(replacement))
                    .replace('%s', String(replacement));
            });
            return output;
        };

        const dialog = root.querySelector('.hk-profile-blocks__dialog');
        const bodyNode = root.querySelector('[data-profile-blocks-body]');
        const personNode = root.querySelector('[data-profile-blocks-person]');
        const progressNode = root.querySelector('[data-profile-blocks-progress]');
        const errorNode = root.querySelector('[data-profile-blocks-error]');
        const errorTextNode = root.querySelector('[data-profile-blocks-error-text]');
        const backButton = root.querySelector('[data-profile-blocks-back]');
        const nextButton = root.querySelector('[data-profile-blocks-next]');
        const backdrop = root.querySelector('[data-profile-blocks-dismiss]');
        if (!bodyNode || !nextButton) {
            return inert;
        }

        const participantsById = {};
        model.participants.forEach((participant) => {
            const contactId = String(participant.contactId || '').trim();
            if (contactId) {
                participantsById[contactId] = participant;
            }
        });

        const conditionalFields = Array.isArray(model.conditionalFields) ? model.conditionalFields : [];
        const stateOptionsCache = Object.assign({}, model.stateOptions || {});
        const collected = {};
        const resolved = {};

        let queue = [];
        let queueIndex = 0;
        let onResolved = null;
        let lastFocused = null;

        const pushDataLayer = (event, payload) => {
            window.dataLayer = window.dataLayer || [];
            const susVars = (typeof window.SUSVars === 'object' && window.SUSVars !== null) ? window.SUSVars : {};
            window.dataLayer.push({
                event,
                comp_core: Object.assign({
                    activity_name: susVars.activity_name || (susVars.activity && susVars.activity.Name) || '',
                    activity_category: susVars.activity_category || susVars.activity_type || '',
                    activity_type: susVars.activity_type || susVars.activity_category || '',
                    page_category: susVars.page_category || '',
                    page_title: document.title,
                    page_url: window.location.href,
                }, payload || {}),
            });
        };

        const normalizeConditionValue = (value) => normalizeLookupValue(String(value || ''));

        const fieldInputType = (field) => {
            switch (String(field.fieldType || '').toUpperCase()) {
                case 'DATE':
                    return 'date';
                case 'EMAIL':
                    return 'email';
                case 'PHONE':
                    return 'tel';
                default:
                    return 'text';
            }
        };

        const isWideField = (field) => {
            const type = String(field.fieldType || '').toUpperCase();
            return type === 'TEXTAREA' || String(field.fieldApiName || '') === 'MailingStreet';
        };

        const currentValueFor = (contactId, field) => {
            const stored = collected[contactId] || {};
            if (Object.prototype.hasOwnProperty.call(stored, field.fieldApiName)) {
                return String(stored[field.fieldApiName] || '');
            }
            return String(field.value || '');
        };

        const buildOptionsMarkup = (options, selectedValue) => {
            const placeholder = `<option value="">${escapeHtml(t('select', 'Selecciona'))}</option>`;
            const rendered = (options || []).map((option) => {
                const value = String(option.value || '');
                const label = String(option.label || value);
                const selected = (value === selectedValue) ? ' selected' : '';
                return `<option value="${escapeHtml(value)}"${selected}>${escapeHtml(label)}</option>`;
            }).join('');
            return placeholder + rendered;
        };

        // Se lee del modelo y de lo ya tecleado, nunca del DOM: en el momento de
        // pintar un paso, el DOM todavía es el del paso anterior.
        const readStoredFieldValue = (contactId, fieldApiName) => {
            const stored = collected[contactId] || {};
            if (Object.prototype.hasOwnProperty.call(stored, fieldApiName)) {
                return String(stored[fieldApiName] || '');
            }
            const participant = participantsById[contactId];
            if (!participant) {
                return '';
            }
            let found = '';
            (participant.blocks || []).forEach((block) => {
                (block.fields || []).forEach((field) => {
                    if (String(field.fieldApiName || '') === fieldApiName) {
                        found = String(field.value || '');
                    }
                });
            });
            return found;
        };

        const resolveSelectOptions = (contactId, field) => {
            if (String(field.fieldApiName || '') !== 'MailingStateCode' || !field.optionsTruncated) {
                return Array.isArray(field.options) ? field.options : [];
            }
            const countryCode = String(readStoredFieldValue(contactId, 'MailingCountryCode') || '').toUpperCase();
            return countryCode && Array.isArray(stateOptionsCache[countryCode]) ? stateOptionsCache[countryCode] : [];
        };

        const renderField = (contactId, field, extra) => {
            const options = Object.assign({ readOnly: !!field.readOnly, conditional: null }, extra || {});
            const fieldApiName = String(field.fieldApiName || '');
            const inputId = `hk-pb-${contactId}-${fieldApiName}`.replace(/[^A-Za-z0-9_-]/g, '-');
            const value = currentValueFor(contactId, field);
            const requiredMark = field.required ? `<span class="hk-profile-blocks__required" aria-hidden="true">*</span>` : '';
            const type = String(field.fieldType || '').toUpperCase();
            const readOnlyAttr = options.readOnly ? ' readonly aria-readonly="true"' : '';
            const requiredAttr = field.required ? ' aria-required="true"' : '';
            const maxLengthAttr = field.maxLength > 0 ? ` maxlength="${Number(field.maxLength)}"` : '';

            let control = '';
            if (type === 'PICKLIST') {
                const selectOptions = resolveSelectOptions(contactId, field);
                const disabledAttr = options.readOnly ? ' disabled' : '';
                control = `<select id="${inputId}" data-profile-field="${escapeHtml(fieldApiName)}"${requiredAttr}${disabledAttr}>${buildOptionsMarkup(selectOptions, value)}</select>`;
            } else if (type === 'TEXTAREA') {
                control = `<textarea id="${inputId}" rows="3" data-profile-field="${escapeHtml(fieldApiName)}"${requiredAttr}${readOnlyAttr}${maxLengthAttr}>${escapeHtml(value)}</textarea>`;
            } else {
                control = `<input id="${inputId}" type="${fieldInputType(field)}" value="${escapeHtml(value)}" data-profile-field="${escapeHtml(fieldApiName)}"${requiredAttr}${readOnlyAttr}${maxLengthAttr}>`;
            }

            const helpParts = [];
            if (field.helpText) {
                helpParts.push(`<p class="hk-profile-blocks__help">${escapeHtml(field.helpText)}</p>`);
            }
            if (options.readOnly) {
                helpParts.push(`<p class="hk-profile-blocks__help">${escapeHtml(t('readOnlyHint', 'Este dato no se puede cambiar desde la web.'))}</p>`);
            }

            const wideClass = isWideField(field) ? ' hk-profile-blocks__field--wide' : '';
            const conditionalAttr = options.conditional ? ` data-profile-conditional="${escapeHtml(fieldApiName)}"` : '';

            return `<div class="hk-profile-blocks__field${wideClass}" data-profile-field-wrapper="${escapeHtml(fieldApiName)}"${conditionalAttr}>
                <label for="${inputId}">${escapeHtml(field.label || fieldApiName)}${requiredMark}</label>
                ${control}
                ${helpParts.join('')}
                <p class="hk-profile-blocks__field-error" data-profile-field-error hidden></p>
            </div>`;
        };

        const conditionalToField = (conditional) => ({
            objectApiName: conditional.objectApiName || 'Contact',
            fieldApiName: conditional.fieldApiName,
            label: conditional.label || conditional.fieldApiName,
            fieldType: conditional.fieldType || 'STRING',
            helpText: conditional.helpText || '',
            options: [],
            optionsTruncated: false,
            value: '',
            required: !!conditional.required,
            readOnly: false,
            filled: false,
            order: 999,
            maxLength: Number(conditional.maxLength || 0),
            pattern: conditional.pattern || '',
            uppercase: !!conditional.uppercase,
        });

        const declaredFieldNames = (participant) => {
            const names = {};
            (participant.blocks || []).forEach((block) => {
                (block.fields || []).forEach((field) => {
                    names[String(field.fieldApiName || '')] = true;
                });
            });
            return names;
        };

        const renderStep = () => {
            const contactId = queue[queueIndex];
            const participant = participantsById[contactId];
            if (!participant) {
                return;
            }

            const blocksMarkup = (participant.blocks || []).map((block) => {
                const fields = (block.fields || []).map((field) => renderField(contactId, field)).join('');
                return `<section class="hk-profile-blocks__block" data-profile-block="${escapeHtml(String(block.key || ''))}">
                    <h3 class="hk-profile-blocks__block-title">${escapeHtml(String(block.label || block.key || ''))}</h3>
                    <div class="hk-profile-blocks__grid">${fields}</div>
                </section>`;
            }).join('');

            bodyNode.innerHTML = blocksMarkup;

            if (personNode) {
                personNode.textContent = format(t('personIntro', 'Datos de %s'), participant.label || '');
                personNode.hidden = !participant.label;
            }
            if (progressNode) {
                const showProgress = queue.length > 1;
                progressNode.textContent = showProgress
                    ? format(t('stepOf', 'Paso %1$s de %2$s'), queueIndex + 1, queue.length)
                    : '';
                progressNode.hidden = !showProgress;
            }
            if (backButton) {
                backButton.hidden = queueIndex === 0;
            }
            nextButton.textContent = (queueIndex === queue.length - 1)
                ? t('finish', 'Guardar y seguir')
                : t('saveAndContinue', 'Guardar y continuar');

            hideGlobalError();
            bindConditionalFields(contactId, participant);
            bindStateRefresh(contactId);

            const editableControls = Array.from(bodyNode.querySelectorAll('[data-profile-field]'))
                .filter((control) => !control.readOnly && !control.disabled);
            const firstEmpty = editableControls.find((control) => String(control.value || '').trim() === '')
                || editableControls[0];
            if (firstEmpty) {
                try {
                    firstEmpty.focus({ preventScroll: true });
                } catch (error) {
                    firstEmpty.focus();
                }
            }

            pushDataLayer('profile_blocks_step', {
                step_number: queueIndex + 1,
                step_total: queue.length,
                blocks_count: (participant.blocks || []).length,
            });
        };

        // Un campo condicionado no viene en el GET mientras no se cumpla su
        // condición. Salesforce la reevalúa con lo que se le manda, así que si
        // aquí no lo pintamos el POST vuelve con 400.
        const bindConditionalFields = (contactId, participant) => {
            const declared = declaredFieldNames(participant);

            conditionalFields.forEach((conditional) => {
                const targetName = String(conditional.fieldApiName || '');
                const parentName = String(conditional.dependsOn || '');
                if (!targetName || !parentName || !declared[parentName]) {
                    return;
                }

                const parentControl = bodyNode.querySelector(`[data-profile-field="${parentName}"]`);
                if (!parentControl) {
                    return;
                }

                const expected = (conditional.values || []).map(normalizeConditionValue);
                const alreadyRendered = () => bodyNode.querySelector(`[data-profile-field-wrapper="${targetName}"]`);

                const sync = (announce) => {
                    const matches = expected.indexOf(normalizeConditionValue(parentControl.value)) !== -1;
                    const existing = alreadyRendered();

                    if (!matches) {
                        if (existing && existing.getAttribute('data-profile-conditional')) {
                            existing.remove();
                        }
                        if (collected[contactId]) {
                            delete collected[contactId][targetName];
                        }
                        return;
                    }

                    if (existing) {
                        return;
                    }

                    // Se cuelga del bloque declarado, y si no, del bloque donde
                    // vive el campo del que depende.
                    const parentWrapper = parentControl.closest('.hk-profile-blocks__field');
                    let host = null;
                    if (conditional.blockKey) {
                        host = bodyNode.querySelector(`[data-profile-block="${conditional.blockKey}"] .hk-profile-blocks__grid`);
                    }
                    if (!host && parentWrapper) {
                        host = parentWrapper.parentElement;
                    }
                    if (!host) {
                        return;
                    }

                    host.insertAdjacentHTML('beforeend', renderField(contactId, conditionalToField(conditional), { conditional: true }));
                    const added = host.querySelector(`[data-profile-field-wrapper="${targetName}"] [data-profile-field]`);
                    if (added && conditional.uppercase) {
                        added.addEventListener('input', () => {
                            const caret = added.selectionStart;
                            added.value = String(added.value || '').toUpperCase();
                            try {
                                added.setSelectionRange(caret, caret);
                            } catch (error) {
                                // Los inputs sin soporte de selección no importan aquí.
                            }
                        });
                    }
                    if (announce) {
                        pushDataLayer('profile_blocks_conditional_shown', {
                            field_api_name: targetName,
                            depends_on: parentName,
                        });
                    }
                };

                parentControl.addEventListener('change', () => sync(true));
                sync(false);
            });
        };

        // `MailingStateCode` llega con `optionsTruncated`: casi 2.000 valores que
        // Salesforce no manda. Se piden al servidor por país de residencia.
        const bindStateRefresh = (contactId) => {
            const countryControl = bodyNode.querySelector('[data-profile-field="MailingCountryCode"]');
            const stateControl = bodyNode.querySelector('[data-profile-field="MailingStateCode"]');
            if (!countryControl || !stateControl) {
                return;
            }

            const applyOptions = (options, keepValue) => {
                const currentValue = keepValue ? String(stateControl.value || '') : '';
                stateControl.innerHTML = buildOptionsMarkup(options, currentValue);
            };

            const refresh = () => {
                const countryCode = String(countryControl.value || '').toUpperCase();
                if (!countryCode) {
                    applyOptions([], false);
                    return;
                }
                if (Array.isArray(stateOptionsCache[countryCode])) {
                    applyOptions(stateOptionsCache[countryCode], false);
                    return;
                }
                fetch(settings.statesUrl || suscriptionsData.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        action: settings.statesAction || 'hk_profile_block_states',
                        country_code: countryCode,
                    }),
                })
                    .then((response) => response.json())
                    .then((result) => {
                        const options = (result && result.success && result.data && Array.isArray(result.data.options))
                            ? result.data.options
                            : [];
                        stateOptionsCache[countryCode] = options;
                        applyOptions(options, false);
                    })
                    .catch(() => {
                        stateOptionsCache[countryCode] = [];
                        applyOptions([], false);
                    });
            };

            countryControl.addEventListener('change', refresh);
            if (!stateControl.options || stateControl.options.length <= 1) {
                refresh();
            }
        };

        const showFieldError = (wrapper, message) => {
            if (!wrapper) {
                return;
            }
            wrapper.classList.add('is-invalid');
            const errorSlot = wrapper.querySelector('[data-profile-field-error]');
            if (errorSlot) {
                errorSlot.textContent = message;
                errorSlot.hidden = false;
            }
        };

        const clearFieldError = (wrapper) => {
            if (!wrapper) {
                return;
            }
            wrapper.classList.remove('is-invalid');
            const errorSlot = wrapper.querySelector('[data-profile-field-error]');
            if (errorSlot) {
                errorSlot.textContent = '';
                errorSlot.hidden = true;
            }
        };

        const showGlobalError = (message) => {
            if (!errorNode || !errorTextNode) {
                return;
            }
            errorTextNode.textContent = message;
            errorNode.hidden = false;
        };

        const hideGlobalError = () => {
            if (errorNode) {
                errorNode.hidden = true;
            }
        };

        const descriptorFor = (contactId, fieldApiName) => {
            const participant = participantsById[contactId];
            let descriptor = null;
            (participant ? participant.blocks || [] : []).forEach((block) => {
                (block.fields || []).forEach((field) => {
                    if (String(field.fieldApiName || '') === fieldApiName) {
                        descriptor = field;
                    }
                });
            });
            if (descriptor) {
                return descriptor;
            }
            const conditional = conditionalFields.find((entry) => String(entry.fieldApiName || '') === fieldApiName);
            return conditional ? conditionalToField(conditional) : null;
        };

        const validateStep = (contactId) => {
            let firstInvalid = null;
            const controls = Array.from(bodyNode.querySelectorAll('[data-profile-field]'));

            controls.forEach((control) => {
                const wrapper = control.closest('.hk-profile-blocks__field');
                clearFieldError(wrapper);

                const fieldApiName = String(control.getAttribute('data-profile-field') || '');
                const descriptor = descriptorFor(contactId, fieldApiName);
                if (!descriptor) {
                    return;
                }
                if (control.readOnly || control.disabled) {
                    return;
                }

                const value = String(control.value || '').trim();

                if (descriptor.required && value === '') {
                    showFieldError(wrapper, t('required', 'Este dato es obligatorio.'));
                    firstInvalid = firstInvalid || control;
                    return;
                }
                if (value === '') {
                    return;
                }

                const type = String(descriptor.fieldType || '').toUpperCase();
                if (type === 'EMAIL' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
                    showFieldError(wrapper, t('invalidEmail', 'Revisa el correo.'));
                    firstInvalid = firstInvalid || control;
                    return;
                }
                if (type === 'DATE' && !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                    showFieldError(wrapper, t('invalidDate', 'Revisa la fecha.'));
                    firstInvalid = firstInvalid || control;
                    return;
                }
                if (descriptor.pattern) {
                    let matches = true;
                    try {
                        matches = new RegExp(`^(?:${descriptor.pattern})$`).test(descriptor.uppercase ? value.toUpperCase() : value);
                    } catch (error) {
                        matches = true;
                    }
                    if (!matches) {
                        const message = t('invalidFormat', 'Ese valor no tiene el formato esperado.');
                        showFieldError(wrapper, message);
                        firstInvalid = firstInvalid || control;
                    }
                }
            });

            if (firstInvalid) {
                showGlobalError(t('reviewErrors', 'Revisa los campos marcados antes de continuar.'));
                pushDataLayer('profile_blocks_error', {
                    error_field: String(firstInvalid.getAttribute('data-profile-field') || ''),
                    step_number: queueIndex + 1,
                });
                try {
                    firstInvalid.focus({ preventScroll: false });
                } catch (error) {
                    firstInvalid.focus();
                }
                return false;
            }

            hideGlobalError();
            return true;
        };

        const collectStep = (contactId) => {
            const values = collected[contactId] || {};
            Array.from(bodyNode.querySelectorAll('[data-profile-field]')).forEach((control) => {
                if (control.readOnly || control.disabled) {
                    return;
                }
                const fieldApiName = String(control.getAttribute('data-profile-field') || '');
                if (!fieldApiName) {
                    return;
                }
                const descriptor = descriptorFor(contactId, fieldApiName);
                // Un campo de solo lectura que ya trae valor lo ignora Salesforce.
                if (descriptor && descriptor.readOnly && descriptor.filled) {
                    return;
                }
                let value = String(control.value || '').trim();
                if (descriptor && descriptor.uppercase) {
                    value = value.toUpperCase();
                }
                if (value === '') {
                    delete values[fieldApiName];
                    return;
                }
                values[fieldApiName] = value;
            });
            collected[contactId] = values;
            resolved[contactId] = true;
        };

        const close = (completedFlow) => {
            root.hidden = true;
            root.classList.remove('is-visible');
            document.body.classList.remove('hk-profile-blocks-open');
            document.removeEventListener('keydown', handleKeydown, true);
            if (!completedFlow) {
                pushDataLayer('profile_blocks_dismissed', { step_number: queueIndex + 1 });
            }
            if (lastFocused && typeof lastFocused.focus === 'function') {
                try {
                    lastFocused.focus({ preventScroll: true });
                } catch (error) {
                    lastFocused.focus();
                }
            }
        };

        const handleKeydown = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                close(false);
            }
        };

        const goNext = () => {
            const contactId = queue[queueIndex];
            if (!validateStep(contactId)) {
                return;
            }
            collectStep(contactId);

            if (queueIndex < queue.length - 1) {
                queueIndex += 1;
                renderStep();
                return;
            }

            pushDataLayer('profile_blocks_completed', {
                status: 'ok',
                participants_count: queue.length,
            });
            const callback = onResolved;
            onResolved = null;
            close(true);
            if (typeof callback === 'function') {
                callback();
            }
        };

        const goBack = () => {
            if (queueIndex === 0) {
                return;
            }
            collectStep(queue[queueIndex]);
            queueIndex -= 1;
            renderStep();
        };

        nextButton.addEventListener('click', goNext);
        if (backButton) {
            backButton.addEventListener('click', goBack);
        }
        if (backdrop) {
            backdrop.addEventListener('click', () => close(false));
        }

        const pendingContactIds = (contactIds) => {
            const wanted = Array.isArray(contactIds) && contactIds.length
                ? contactIds
                : Object.keys(participantsById);
            return wanted
                .map((contactId) => String(contactId || '').trim())
                .filter((contactId) => contactId && participantsById[contactId] && !resolved[contactId]);
        };

        const open = (contactIds, trigger, callback) => {
            const pending = pendingContactIds(contactIds);
            if (!pending.length) {
                if (typeof callback === 'function') {
                    callback();
                }
                return;
            }

            queue = pending;
            queueIndex = 0;
            onResolved = typeof callback === 'function' ? callback : null;
            lastFocused = document.activeElement;

            root.hidden = false;
            root.classList.add('is-visible');
            document.body.classList.add('hk-profile-blocks-open');
            document.addEventListener('keydown', handleKeydown, true);

            // La vista se declara antes del primer paso para que el orden de
            // eventos en GA4 sea el que se lee: apertura y luego pasos.
            pushDataLayer('profile_blocks_view', {
                trigger: String(trigger || 'load'),
                participants_count: queue.length,
                blocks_count: queue.reduce((total, contactId) => {
                    const participant = participantsById[contactId];
                    return total + ((participant && participant.blocks) ? participant.blocks.length : 0);
                }, 0),
            });

            renderStep();
            if (dialog) {
                try {
                    dialog.focus({ preventScroll: true });
                } catch (error) {
                    dialog.focus();
                }
            }
        };

        const getPayload = (contactIds) => {
            const allowed = Array.isArray(contactIds) && contactIds.length ? contactIds.map(String) : null;
            const payload = {};
            Object.keys(collected).forEach((contactId) => {
                if (allowed && allowed.indexOf(contactId) === -1) {
                    return;
                }
                if (collected[contactId] && Object.keys(collected[contactId]).length) {
                    payload[contactId] = collected[contactId];
                }
            });
            return payload;
        };

        return {
            enabled: true,
            responsibleContactId: String(model.responsibleContactId || ''),
            isResolvedFor: (contactIds) => pendingContactIds(contactIds).length === 0,
            pendingContactIds,
            open,
            getPayload,
            reset: (contactIds) => {
                (Array.isArray(contactIds) ? contactIds : Object.keys(resolved)).forEach((contactId) => {
                    delete resolved[String(contactId)];
                });
            },
        };
    })();

    // Contactos que van de verdad en esta inscripción. Solo a esos se les pide
    // ficha: no tiene sentido exigir datos de un familiar que no se apunta.
    const getRegistrationContactIds = () => {
        const ids = [];
        const ownerInput = form.querySelector('input[name="ContactId"]');
        if (ownerInput && String(ownerInput.value || '').trim()) {
            ids.push(String(ownerInput.value).trim());
        }
        if (profileBlocks.enabled && profileBlocks.responsibleContactId) {
            ids.push(profileBlocks.responsibleContactId);
        }
        getParticipantSections().forEach((section) => {
            const contactId = String(section.dataset.contactId || '').trim();
            if (contactId) {
                ids.push(contactId);
            }
        });
        const familySelect = form.querySelector('#family_members');
        if (familySelect) {
            Array.from(familySelect.selectedOptions || []).forEach((option) => {
                const value = String(option.value || '').trim();
                if (value) {
                    ids.push(value);
                }
            });
        }
        return ids.filter((value, position) => ids.indexOf(value) === position);
    };

    // Si Salesforce vuelve a rechazar tras haber reabierto el modal, no se
    // insiste: se enseña el aviso y se deja salir. Un bucle de reintentos con
    // un dato que el cliente no sabe pedir es peor que un mensaje honesto.
    let profileBlocksReopenAttempts = 0;

    // Apertura al cargar: solo para el responsable, que es el único que seguro
    // se inscribe. Los familiares se piden al enviar, y solo los seleccionados.
    if (profileBlocks.enabled && profileBlocks.responsibleContactId) {
        profileBlocks.open([profileBlocks.responsibleContactId], 'load', null);
    }

    form.addEventListener('submit', function (event) {

        event.preventDefault();

        if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
            return;
        }
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
            return;
        }

        // Muro de ficha: si a alguien de los que se inscriben le faltan datos,
        // se piden antes de enviar. Al terminar el modal se reenvía solo.
        const registrationContactIds = getRegistrationContactIds();
        if (profileBlocks.enabled && !profileBlocks.isResolvedFor(registrationContactIds)) {
            profileBlocks.open(registrationContactIds, 'submit', () => {
                if (typeof form.requestSubmit === 'function') {
                    form.requestSubmit();
                } else {
                    form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                }
            });
            return;
        }

        const formData = new FormData(form);
        const enrichedData = isMultiParticipantFlow
            ? buildMultiParticipantPayload()
            : buildLegacyPayload(formData);
        enrichedData.requestKey = ensureActivityRequestKey();
        if (profileBlocks.enabled) {
            const profileBlocksPayload = profileBlocks.getPayload(registrationContactIds);
            if (Object.keys(profileBlocksPayload).length) {
                enrichedData.profileBlocks = profileBlocksPayload;
            }
        }
        if (isGuestRegistrationForm) {
            compactLegacyPayloadGroupValues(enrichedData.ProgramEnrollment);
            compactLegacyPayloadGroupValues(enrichedData.Contact);
            compactLegacyPayloadGroupValues(enrichedData.Processes);
            enrichedData.guestRegistration = true;
            enrichedData.guestContact = flattenLegacyPayloadGroup(enrichedData.guestContact || {});
        }

        // Legacy single flow: el `buildLegacyPayload` no agrupa por participante.
        // Si el checkbox de derechos de imagen está en el form y marcado, lo
        // propagamos como `hk_participant_answers.self.Contact.HKN_AceptaDerechosImagen__c=true`
        // para que el backend lo mapee al contactId del responsable.
        if (!isMultiParticipantFlow) {
            form.querySelectorAll('input[type="checkbox"][data-image-rights-consent="1"]').forEach((consent) => {
                if (!consent.checked || consent.disabled) {
                    return;
                }
                const participantKey = String(consent.dataset.participantKey || 'self').trim() || 'self';
                const normalizedParticipantKey = participantKey === '__legacy__' ? 'self' : participantKey;
                const sfObject = String(consent.dataset.sfObject || 'Contact').trim() || 'Contact';
                const sfField = String(consent.dataset.sfField || 'HKN_AceptaDerechosImagen__c').trim() || 'HKN_AceptaDerechosImagen__c';
                const fieldKey = `${sfObject}.${sfField}`;
                enrichedData.hk_participant_answers = enrichedData.hk_participant_answers || {};
                enrichedData.hk_participant_answers[normalizedParticipantKey] = enrichedData.hk_participant_answers[normalizedParticipantKey] || {};
                enrichedData.hk_participant_answers[normalizedParticipantKey][fieldKey] = true;
            });
        }


        const submitButton = form.querySelector('.button-primary');
        const okNotice = document.querySelector('.ok-notice');
        const okParagraph = okNotice?.querySelector('p');
        const errorNotice = document.querySelector('.error-notice');
        const errorParagraph = errorNotice?.querySelector('p');
        let status = 'ko';
        const showErrorNotice = (message) => {
            if (!errorNotice || !errorParagraph) {
                return;
            }
            errorParagraph.textContent = message || suscriptionsData?.text?.requesterror || 'Error inesperado. Inténtalo de nuevo.';
            errorNotice.hidden = false;
            errorNotice.style.display = 'flex';
            errorNotice.setAttribute('tabindex', '-1');
            try {
                errorNotice.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } catch (scrollError) {
                errorNotice.scrollIntoView();
            }
            try {
                errorNotice.focus({ preventScroll: true });
            } catch (focusError) {
                errorNotice.focus();
            }
        };

        if (okNotice) {
            okNotice.style.display = 'none';
        }
        if (errorNotice) {
            errorNotice.style.display = 'none';
        }

        // Deshabilitar el botón y cambiar el texto
        if (submitButton) {
            submitButton.disabled = true;
            // Guardamos el texto original para restaurarlo después
            const originalText = submitButton.value || submitButton.innerText;
            submitButton.dataset.originalText = originalText;

            const originalBackground = submitButton.style.backgroundColor;
            submitButton.dataset.originalBackground = originalBackground;

            submitButton.style.background = 'gray';
            setSubmitButtonText(submitButton, suscriptionsData.text.processing);
            showSubmitProgress(submitButton);
        }
        const fd = new FormData();
        fd.append('action', formData.get('action'));
        fd.append('_wpnonce', formData.get('_wpnonce'));
        fd.append('_wp_http_referer', formData.get('_wp_http_referer'));
        fd.append('payload', JSON.stringify(enrichedData)); // tu objeto

        fetch(suscriptionsData.ajax_url, {
            method: 'POST',
            body: fd
        })
            .then(async (response) => {
                syncServerClock(response);
                const rawText = await response.text();
                const parsed = tryParseActivityResponse(rawText);

                if (parsed) {
                    return parsed;
                }

                throw new Error(extractActivityErrorMessageFromRawResponse(rawText));
            })
            .then( result => {
                // Con la respuesta ya en casa toma el relevo el modal, el aviso
                // de redirección o el error.
                hideSubmitProgress(submitButton);
                window.dataLayer = window.dataLayer || [];
                const ACTIVITY_REGISTRATION_FORM = document.getElementById('register-activity-form');
                if( result.success ) {
                    status = 'ok'
                    const responseData = result.data || {};
                    const successMessage = String(
                        responseData.economicBlockMessage
                        || responseData.message
                        || 'Envío correcto'
                    ).trim() || 'Envío correcto';
                    const isEconomicBlockEnrollment = Boolean(responseData.economicBlock);
                    if (okNotice && okParagraph) {
                        if (errorNotice) {
                            errorNotice.style.display = 'none';
                        }
                        if (submitButton) {
                            submitButton.disabled = true;
                            setSubmitButtonText(submitButton, suscriptionsData.text.registrationcompleted);
                            const originalBackground = submitButton.dataset.originalBackground;
                            submitButton.style.background = originalBackground || '';
                        }
                        okParagraph.textContent = successMessage;
                        okNotice.style.display = 'flex';
                        //form.reset();

                        if( ACTIVITY_REGISTRATION_FORM ) {
                            const susVars = (typeof window.SUSVars === 'object' && window.SUSVars !== null)
                                ? window.SUSVars
                                : {};
                            const ACTIVITY_FORM_COMPLETED = {
                                event: 'activity_form_completed',
                                comp_core: {
                                    activity_name: susVars.activity_name || susVars.activity?.Name || '',
                                    activity_category: susVars.activity_category || susVars.activity_type || '',
                                    activity_type: susVars.activity_type || susVars.activity_category || '',
                                    email_form_sha: susVars.userEmail || susVars.user_email || '',
                                    status: 'ok',
                                    page_category: susVars.page_category || '',
                                    page_title: document.title,
                                    page_url: window.location.href,
                                }
                            }
                            window.dataLayer.push( ACTIVITY_FORM_COMPLETED )
                            window.dataLayer.push({
                                event: 'activity_registration_completed',
                                comp_core: ACTIVITY_FORM_COMPLETED.comp_core
                            })
                        }
                        const paymentMethodSelected = String(formData.get('HKN_MetodoPago__c') || '');
                        const isGodstopEnrollment = Boolean(responseData.isGodstop);
                        const isMultiEnrollment = Boolean(responseData.multiEnrollment);
                        const registrationGroupId = String(responseData.registrationGroupId || '').trim();
                        const statusValue = normalizeLookupValue(String(responseData.status || ''));
                        const enrollmentStatuses = Array.isArray(responseData.enrollments)
                            ? responseData.enrollments.map((enrollment) => String(enrollment?.status || ''))
                            : [];
                        const isWaitlistEnrollment = Boolean(responseData.isWaitlist)
                            || Boolean(responseData.pendingConfirmation)
                            || isPendingConfirmationStatus(statusValue)
                            || enrollmentStatuses.some(isPendingConfirmationStatus);
                        const shouldTryPaymentLink = Object.prototype.hasOwnProperty.call(responseData || {}, 'shouldCheckPaymentLink')
                            ? Boolean(responseData.shouldCheckPaymentLink) && !isWaitlistEnrollment && !isEconomicBlockEnrollment
                            : (!isWaitlistEnrollment && !isEconomicBlockEnrollment && isGodstopEnrollment && isCardPaymentMethod(paymentMethodSelected));
                        const enrollmentId = String(responseData.enrollmentId || '').trim();
                        const immediatePaymentUrl = String(responseData.paymentUrl || '').trim();
                        const paymentId = String(responseData.paymentId || '').trim();
                        const paymentLinkToken = String(responseData.paymentLinkToken || '').trim();
                        const isGuestRegistration = Boolean(responseData.guestRegistration)
                            || isGuestRegistrationForm;
                        const canPollPaymentLink = shouldTryPaymentLink
                            && enrollmentId
                            && (!isGuestRegistration || paymentLinkToken);
                        const isReservedEnrollment = isReservedEnrollmentStatus(statusValue)
                            || enrollmentStatuses.some(isReservedEnrollmentStatus);
                        const isConfirmedEnrollment = isConfirmedEnrollmentStatus(statusValue)
                            || enrollmentStatuses.some(isConfirmedEnrollmentStatus);
                        const canUsePaymentFlow = isConfirmedEnrollment
                            && !isWaitlistEnrollment
                            && !isEconomicBlockEnrollment
                            && (
                                immediatePaymentUrl
                                || (!isGuestRegistration && paymentId)
                                || canPollPaymentLink
                            );
                        const inscriptionsUrl = isGuestRegistration
                            ? getGuestRedirectUrl(responseData || {})
                            : getInscriptionsRedirectUrl(responseData || {});
                        const pendingRedirectDelay = (isEconomicBlockEnrollment || isWaitlistEnrollment)
                            ? PENDING_REDIRECT_DELAY_MS
                            : REDIRECT_DELAY_MS;
                        const redirectingInscriptionsMessage = (isEconomicBlockEnrollment || isWaitlistEnrollment)
                            ? successMessage
                            : (
                                isGuestRegistration
                                    ? (suscriptionsData?.text?.redirectingguest || 'Inscripción recibida. Volviendo a la actividad...')
                                    : (suscriptionsData?.text?.redirectinginscriptions || 'Inscripcion completada. Redirigiendo a tus inscripciones...')
                            );
                        const initialOverlayMessage = (isEconomicBlockEnrollment || isWaitlistEnrollment)
                            ? successMessage
                            : (suscriptionsData?.text?.redirecting || 'Formulario enviado. Redirigiendo...');
                        lockFormForRedirect(form);

                        // KAN-264: plaza Reservada. No se salta solo al pago: el
                        // modal cuenta el tiempo que queda y el botón «Pagar» se
                        // activa cuando llega el enlace. La hora límite es la de
                        // la inscripción o, si no viene, la del checkout, que
                        // también trae el sondeo del enlace.
                        if (isReservedEnrollment && !isWaitlistEnrollment && !isEconomicBlockEnrollment) {
                            const reservationModal = openReservationCheckoutModal({
                                expiresAtUnixSeconds: responseData.reservationExpiresAtUnixSeconds
                                    || responseData.checkoutExpiresAtUnixSeconds
                                    || 0,
                                profileUrl: isGuestRegistration ? '' : inscriptionsUrl,
                                track: pushRegistrationEvent,
                            });
                            if (immediatePaymentUrl) {
                                reservationModal.setPaymentUrl(immediatePaymentUrl);
                                return;
                            }
                            if (!canPollPaymentLink) {
                                reservationModal.setUnavailable();
                                return;
                            }
                            const requestReservationPaymentLink = () => {
                                reservationModal.setPending();
                                pollForPaymentLink(enrollmentId, paymentLinkToken, (paymentLinkData) => {
                                    if (paymentLinkData?.reservationExpired) {
                                        reservationModal.expire();
                                        return;
                                    }
                                    reservationModal.setExpiry(paymentLinkData?.checkoutExpiresAtUnixSeconds);
                                }).then((polledPaymentUrl) => {
                                    if (polledPaymentUrl) {
                                        reservationModal.setPaymentUrl(polledPaymentUrl);
                                    } else {
                                        reservationModal.setUnavailable(requestReservationPaymentLink);
                                    }
                                });
                            };
                            requestReservationPaymentLink();
                            return;
                        }

                        showRedirectOverlay(initialOverlayMessage);

                        const redirectTo = (targetUrl, redirectMessage, delayMs = REDIRECT_DELAY_MS) => {
                            showRedirectOverlay(redirectMessage);
                            setTimeout(() => {
                                window.location.href = targetUrl;
                            }, delayMs);
                        };

                        if (canUsePaymentFlow && immediatePaymentUrl) {
                            redirectTo(
                                immediatePaymentUrl,
                                suscriptionsData?.text?.redirectingpayment || 'Inscripcion completada. Redirigiendo al pago...'
                            );
                            return;
                        }

                        if (canUsePaymentFlow && canPollPaymentLink) {
                            showRedirectOverlay(
                                suscriptionsData?.text?.checkingpayment || 'Preparando enlace de pago...'
                            );
                            const paymentLinkPromise = enrollmentId
                                ? pollForPaymentLink(enrollmentId, paymentLinkToken)
                                : wait(Math.max(1800, REDIRECT_DELAY_MS * 2)).then(() => '');
                            paymentLinkPromise.then((polledPaymentUrl) => {
                                if (polledPaymentUrl) {
                                    redirectTo(
                                        polledPaymentUrl,
                                        suscriptionsData?.text?.redirectingpayment || 'Inscripcion completada. Redirigiendo al pago...'
                                    );
                                    return;
                                }

                                redirectTo(
                                    inscriptionsUrl,
                                    redirectingInscriptionsMessage
                                );
                            });
                            return;
                        }

                        if (isMultiEnrollment || registrationGroupId) {
                            redirectTo(
                                inscriptionsUrl,
                                redirectingInscriptionsMessage,
                                pendingRedirectDelay
                            );
                            return;
                        }

                        redirectTo(
                            inscriptionsUrl,
                            redirectingInscriptionsMessage,
                            pendingRedirectDelay
                        );
                    }
                } else {
                    // Salesforce ha rechazado por ficha incompleta. No enseñamos
                    // su mensaje (viene con etiquetas de campo y en el idioma del
                    // usuario de integración): reabrimos el modal con los mismos
                    // bloques para que la persona lo arregle sin perder el envío.
                    if (
                        String(result.data?.code || '') === 'profile_blocks_required'
                        && profileBlocks.enabled
                        && profileBlocksReopenAttempts < 1
                    ) {
                        profileBlocksReopenAttempts += 1;
                        restoreSubmitButton(submitButton);
                        profileBlocks.reset(registrationContactIds);
                        profileBlocks.open(registrationContactIds, 'server_rejection', () => {
                            if (typeof form.requestSubmit === 'function') {
                                form.requestSubmit();
                            } else {
                                form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                            }
                        });
                        return;
                    }
                    let errorMessage = result.data?.message || suscriptionsData?.text?.unknowerror || 'Error desconocido';
                    const sfErrors = Array.isArray(result.data?.errors) ? result.data.errors : [];
                    if (
                        sfErrors.length > 0 &&
                        (
                            errorMessage === 'Error al procesar el formulario.'
                            || errorMessage === 'Error desconocido'
                            || errorMessage === suscriptionsData?.text?.unknowerror
                        )
                    ) {
                        errorMessage = sfErrors[0];
                    }
                    showErrorNotice(errorMessage);
                    if (okNotice) {
                        okNotice.style.display = 'none';
                    }
                    restoreSubmitButton(submitButton);
                    if( ACTIVITY_REGISTRATION_FORM ) {
                        const susVars = (typeof window.SUSVars === 'object' && window.SUSVars !== null)
                            ? window.SUSVars
                            : {};
                        const ACTIVITY_FORM_COMPLETED = {
                            event: 'activity_form_completed',
                            comp_core: {
                                activity_name: susVars.activity_name || susVars.activity?.Name || '',
                                activity_category: susVars.activity_category || susVars.activity_type || '',
                                activity_type: susVars.activity_type || susVars.activity_category || '',
                                email_form_sha: susVars.userEmail || susVars.user_email || '',
                                status: 'ko',
                                page_category: susVars.page_category || '',
                                page_title: document.title,
                                page_url: window.location.href,
                            }
                        }
                        window.dataLayer.push( ACTIVITY_FORM_COMPLETED )
                    }
                }
            })
            .catch(error => {
                showErrorNotice(error?.message || suscriptionsData?.text?.requesterror || 'Error de comunicación. Por favor, inténtalo de nuevo.');
                if (okNotice) {
                    okNotice.style.display = 'none';
                }
                restoreSubmitButton(submitButton);
            })
            .finally(() => {

            });
    })
})
